{
  "es": {
    "product": "Cryptology Assist",
    "workspace": "Espacio de trabajo",
    "inbox": "Conversaciones",
    "configuration": "Asistente",
    "knowledge": "Conocimiento",
    "connections": "Conexiones",
    "usage": "Uso",
    "signIn": "Inicia sesión para continuar",
    "SIGN_IN_REQUIRED": "Tu sesión ha finalizado. Inicia sesión para continuar.",
    "noIdentityProviders": "No hay un proveedor de acceso configurado. Contacta a tu administrador.",
    "google": "Continuar con Google",
    "microsoft": "Continuar con Microsoft",
    "signOut": "Cerrar sesión",
    "selectBot": "Selecciona un asistente",
    "noBots": "Tu cuenta aún no tiene asistentes asignados.",
    "accountId": "ID de tu cuenta",
    "loading": "Cargando…",
    "retry": "Reintentar",
    "error": "No se pudo completar la solicitud.",
    "empty": "No hay conversaciones todavía.",
    "selectConversation": "Selecciona una conversación",
    "chat": "Chat web",
    "email": "Email",
    "customer": "Cliente",
    "assistant": "Asistente",
    "operator": "Operador",
    "automatic": "Automático",
    "human": "Atención humana",
    "stopped": "Contacto detenido",
    "takeOver": "Tomar conversación",
    "resume": "Reactivar asistente",
    "stop": "Detener contacto",
    "send": "Enviar respuesta",
    "reply": "Tu respuesta",
    "draft": "Borrador",
    "approve": "Aprobar y enviar",
    "cancel": "Descartar",
    "holds": "Pausas de seguimiento",
    "actions": "Acciones",
    "attachments": "Archivos",
    "download": "Descargar",
    "reviewApprove": "Marcar como revisado",
    "reviewReject": "Rechazar archivo",
    "verified": "Cuenta verificada",
    "unverified": "Cuenta sin verificar",
    "save": "Guardar",
    "saved": "Guardado",
    "name": "Nombre del asistente",
    "businessName": "Nombre de la empresa",
    "locale": "Idioma",
    "formality": "Estilo",
    "formal": "Formal",
    "conversational": "Conversacional",
    "personality": "Personalidad y voz",
    "personalityHelp": "Describe cómo habla el asistente: ritmo, calidez y expresiones propias de tu marca. Esto no cambia los datos, permisos ni reglas de confirmación.",
    "instructions": "Instrucciones de comunicación",
    "signature": "Firma de email",
    "capabilities": "Resultados y funciones",
    "offerings": "Explicar productos y servicios",
    "sales": "Ventas y citas",
    "collections": "Cobranza",
    "channels": "Canales",
    "chatOrigins": "Sitios autorizados para el chat (uno por línea)",
    "enableChat": "Activar chat",
    "enableEmail": "Activar email",
    "emailMode": "Respuestas por email",
    "draftMode": "Revisión antes de enviar",
    "automaticMode": "Enviar respuestas validadas",
    "calendar": "Calendario de citas",
    "noCalendar": "Sin calendario",
    "calendarAccount": "Cuenta de calendario",
    "calendarChoice": "Calendario",
    "appointmentKind": "Tipo de cita",
    "siteVisit": "Visita presencial",
    "salesCall": "Llamada con ventas",
    "timezone": "Zona horaria",
    "duration": "Duración de cita (minutos)",
    "workingDays": "Días de atención",
    "opensAt": "Desde",
    "closesAt": "Hasta",
    "closed": "Cerrado",
    "businessConnection": "Fuente de catálogo y datos actuales",
    "noBusinessConnection": "Sin conexión",
    "configurationHelp": "Describe el negocio, elige sus resultados y configura cómo conversa. Guarda un borrador, pruébalo y publica cuando esté listo.",
    "connectGoogle": "Conectar Gmail y Google Calendar",
    "connectMicrosoft": "Conectar Microsoft 365 y Outlook Calendar",
    "mailboxes": "Cuentas conectadas",
    "lastSync": "Última sincronización",
    "notSynced": "Sin sincronización registrada",
    "disable": "Desconectar",
    "enable": "Reactivar conexión",
    "businessSystems": "Catálogo, ventas y cuentas por cobrar",
    "provider": "Proveedor",
    "endpoint": "Dirección del conector",
    "credential": "Credencial del conector",
    "connect": "Validar y conectar",
    "external": "Sistema externo",
    "knowledgeHelp": "Publica contenido verificado. Cada respuesta conserva la fuente y la versión utilizada.",
    "source": "Fuente",
    "sourceType": "Tipo de fuente",
    "content": "Contenido verificado",
    "publish": "Revisar y publicar",
    "noKnowledge": "No hay fuentes publicadas.",
    "website": "Sitio web",
    "document": "Documento",
    "manual": "Contenido propio",
    "approved_chat_learning": "Aprendizaje revisado",
    "status": "Estado",
    "subscription": "Suscripción",
    "period": "Periodo",
    "conversationsUsed": "Conversaciones utilizadas",
    "planPeriodEnds": "El periodo termina",
    "planCapacityLow": "Al plan le quedan pocas conversaciones en este periodo. Cuando se agoten, el asistente dejará de responder a clientes nuevos.",
    "planCapacityExhausted": "El asistente no está respondiendo a clientes nuevos: el plan ya no tiene conversaciones en este periodo.",
    "planCapacityExhaustedHelp": "Los clientes que escribieron en las últimas 24 horas siguen recibiendo respuesta.",
    "planCapacityInactive": "El asistente no está respondiendo a clientes nuevos: la suscripción no tiene un periodo activo.",
    "planCapacityOpen": "Ver uso y plan",
    "included": "Incluidas en el plan",
    "monthlyPrice": "Precio mensual",
    "modelUsage": "Uso de modelos",
    "model": "Modelo",
    "operations": "Operaciones",
    "inputTokens": "Tokens de entrada",
    "cachedTokens": "Tokens en caché",
    "outputTokens": "Tokens de salida",
    "providerCost": "Costo del proveedor",
    "unpriced": "Operaciones sin costo confirmado",
    "noUsage": "No hay operaciones de modelos registradas en este periodo.",
    "confirmationTitle": "Revisa tu solicitud",
    "confirmationHelp": "Confirma los datos antes de continuar.",
    "confirm": "Confirmar solicitud",
    "confirmationSent": "Tu confirmación quedó registrada. Recibirás el resultado cuando el sistema complete la operación.",
    "invalidLink": "Este enlace de confirmación no es válido o ya venció.",
    "lead": "Solicitud comercial",
    "appointment": "Cita",
    "paymentProposal": "Propuesta de pago",
    "amount": "Importe",
    "date": "Fecha",
    "reference": "Referencia",
    "resolve": "Resolver pausa",
    "resolutionNote": "Resultado de la revisión",
    "loadMore": "Ver conversaciones anteriores",
    "client": "Cliente",
    "role": "Permiso",
    "team": "Acceso del equipo",
    "grant": "Guardar acceso",
    "owner": "Propietario",
    "admin": "Administrador",
    "viewer": "Lectura",
    "identityHelp": "Comparte tu ID de cuenta con quien administra el asistente para recibir acceso.",
    "connectionHelp": "Autoriza cada buzón y elige un calendario en la configuración del asistente.",
    "models": "Jev · Luna configurable",
    "refresh": "Actualizar",
    "request": "Solicitud",
    "acknowledgement": "Confirmación del sistema",
    "available": "Disponible",
    "noConnections": "No hay buzones conectados.",
    "embed": "Instalar chat",
    "embedHelp": "Usa este módulo en uno de los sitios autorizados.",
    "copy": "Copiar",
    "approved": "Revisado",
    "quarantined": "Pendiente de revisión",
    "rejected": "Rechazado",
    "pending": "Pendiente",
    "accepted": "Aceptado por el sistema",
    "confirmed": "Confirmado",
    "failed": "Falló",
    "cancelled": "Cancelado",
    "reconciliation_required": "Requiere conciliación",
    "awaiting_confirmation": "Espera confirmación del cliente",
    "executing": "En proceso",
    "ready": "Conectado",
    "syncing": "Sincronizando",
    "disabled": "Desconectado",
    "active": "Activo",
    "installing": "En configuración",
    "payment_claim": "Pago por verificar",
    "dispute": "Reclamo",
    "human_hold": "Revisión humana",
    "opt_out": "Solicitud de no contacto",
    "pending_triage": "Mensaje pendiente de clasificación",
    "source_unavailable": "Fuente no disponible",
    "notes": "Observaciones",
    "editRole": "Cambiar rol",
    "revoke": "Revocar",
    "mailboxIdentifier": "Identificador del buzón",
    "approvedReplies": "Respuestas aprobadas",
    "approvedReplyHelp": "Revisa las respuestas a preguntas estáticas y sus variantes antes de usarlas. Ingresa una pregunta por línea. Se invalidan cuando cambia el conocimiento o la configuración. Precios, saldos y disponibilidad requieren una fuente actual.",
    "noQuestion": "Pregunta no registrada",
    "questions": "Preguntas y variantes aprobadas",
    "answer": "Respuesta revisada",
    "expires": "Vencimiento (tu hora local)",
    "mailImportFailures": "Mensajes que requieren revisión de importación",
    "mailImportHelp": "No se pudieron importar estos mensajes. Los demás siguen sincronizándose. Revisa el error en el buzón de origen y reintenta. La página se vuelve a procesar sin duplicar conversaciones.",
    "serviceUnavailable": "El servicio no devolvió una respuesta válida. Reintenta o contacta a tu administrador.",
    "caseId": "Caso revisado en el sistema de origen",
    "verifyAccount": "Verificar mi cuenta",
    "verifyAccountHelp": "Verifica tu acceso para consultar tu cuenta en esta conversación de correo. Si no solicitaste este enlace, cierra esta página.",
    "accountVerifiedHelp": "Cuenta verificada. Responde al correo para continuar. Si tu acceso vence, solicita un nuevo enlace en esa conversación.",
    "checkDelivery": "Consultar estado de entrega en el proveedor",
    "quality": "Calidad",
    "qualityHelp": "Etiqueta mensajes reales de forma independiente. El email automático requiere 100 conversaciones revisadas, 20 positivas por señal obligatoria, 95% de precisión y ninguna omisión. Baja y ayuda humana son siempre obligatorias; reclamos y disputas también cuando cobranza está habilitada. Se miden las cuatro señales. Hasta aprobar, una persona revisa cada email. Esto no evalúa la redacción.",
    "qualityPassed": "Evaluación del clasificador aprobada. Aún se requiere revisión de redacción y aceptación real del cliente.",
    "qualityReviewRequired": "El email generado requiere revisión de una persona.",
    "qualityConversations": "Conversaciones revisadas",
    "qualityMessages": "Mensajes revisados",
    "qualitySignal": "Señal",
    "qualityPositive": "Conversaciones positivas",
    "qualityFalsePositive": "Falsas alarmas",
    "qualityMissed": "Señales omitidas",
    "qualityPaymentClaim": "Afirma haber pagado",
    "qualityDispute": "Disputa la deuda o el importe",
    "qualityStop": "Solicita no recibir más contacto",
    "qualityHuman": "Requiere atención de una persona",
    "selectAnswer": "Selecciona una respuesta",
    "yes": "Sí",
    "no": "No",
    "searchConversation": "Correo del cliente o ID de conversación",
    "search": "Buscar",
    "needsAttention": "Requiere atención",
    "assignedToMe": "Asignadas a mí",
    "firstPage": "Volver al inicio",
    "assignee": "Operador responsable",
    "reviewDeadline": "Plazo de atención",
    "assign": "Asignar revisión",
    "importKnowledge": "Importar una fuente",
    "importKnowledgeHelp": "Importa una página web autorizada o sube un PDF, texto, Markdown o HTML de hasta 2 MB. Revisa el texto extraído antes de publicar.",
    "sourceDocument": "Documento (deja vacío para consultar la URL)",
    "captureSource": "Leer fuente",
    "reviewImportedSource": "Confirma que todo el contenido extraído sea correcto y esté aprobado para responder a los clientes.",
    "revokeKnowledge": "Revocar fuente",
    "adoptPolicy": "Aplicar política publicada a conversaciones abiertas",
    "adoptPolicyHelp": "Aplica el perfil publicado a conversaciones existentes solo si no afecta respuestas, confirmaciones u operaciones pendientes. Se conserva el trabajo existente. Cambiar una fuente conectada o servicio de citas requiere una conversación nueva.",
    "adoptionApplied": "Conversaciones actualizadas",
    "adoptionKept": "Conversaciones conservadas en su versión anterior",
    "calendarConfirmed": "Reserva confirmada por el calendario",
    "recoveryAttempts": "Intentos de recuperación",
    "reconcileAction": "Consultar y conciliar el resultado",
    "retryRead": "Volver a consultar la fuente",
    "holdReviewAction": "Acción de revisión",
    "createReviewCase": "Crear caso para revisión en el sistema de origen",
    "correctFalsePositive": "Corregir clasificación incorrecta",
    "caseHoldRetained": "El caso queda vinculado a este mensaje. La pausa continúa hasta que el sistema de origen confirme el resultado de la revisión.",
    "falsePositiveRule": "Revisa el mensaje original y explica por qué no es un reclamo de pago ni una disputa. Solo se permite si no existe un caso. No modifica la exclusión de comunicaciones.",
    "qualityRequirement": "Requisito para las tareas activas",
    "qualityRequired": "Requerido",
    "qualityMeasuredOnly": "Medido; requerido al activar cobranza",
    "readiness": "Diagnóstico de instalación",
    "readinessHelp": "Verifica la configuración publicada, periodo de suscripción, acceso a fuentes, identidad del buzón, permisos del calendario y revisión del clasificador. Estas verificaciones de lectura no reemplazan pruebas reales de ventas, pagos, lenguaje o entrega. La titularidad de automatización del buzón debe coordinarse con otras aplicaciones.",
    "runDiagnostics": "Ejecutar verificaciones",
    "diagnosticArea": "Área",
    "diagnosticResult": "Resultado",
    "diagnosticNextStep": "Abrir configuración",
    "diagnosticPassed": "Verificación correcta",
    "diagnosticBlocked": "Requiere acción",
    "diagnosticReview": "Requiere revisión independiente",
    "diagnosticCapacityLow": "Quedan pocas conversaciones",
    "diagnosticDisabled": "No habilitado",
    "authoritativeResults": "Resultados de la fuente",
    "handoffOperations": "Atención humana",
    "handoffPolicyMissing": "Configura responsables y plazo para activar las alertas y el escalamiento de solicitudes humanas.",
    "initialAssignee": "Responsable inicial",
    "escalationAssignee": "Responsable del escalamiento",
    "responseMinutes": "Plazo de respuesta (minutos)",
    "overdueHandoffs": "Solicitudes vencidas asignadas a ti",
    "noHandoffAlerts": "No tienes alertas pendientes.",
    "acknowledgeAlert": "Marcar alerta como vista",
    "openConversation": "Abrir conversación",
    "HANDOFF_ASSIGNEE_NOT_AUTHORIZED": "Selecciona un responsable autorizado para este asistente.",
    "HANDOFF_ESCALATION_NOT_CONFIGURED": "Configura un responsable autorizado para el escalamiento.",
    "selectAssignee": "Seleccionar responsable",
    "openHandoffAlerts": "Revisar solicitudes vencidas",
    "saveHandoffPolicy": "Guardar atención humana",
    "HANDOFF_POLICY_MEMBER_REQUIRED": "Actualiza los responsables de atención humana antes de retirar este acceso.",
    "appointments": "Citas",
    "noAppointments": "No se han reservado citas en esta conversación.",
    "appointmentCancelled": "Cancelada en el calendario.",
    "appointmentChange": "Modificar cita",
    "rescheduleAppointment": "Reprogramar cita",
    "cancelAppointment": "Cancelar cita",
    "appointmentLocalTime": "Ingresa el nuevo horario en la zona horaria local de tu dispositivo.",
    "appointmentStarts": "Nuevo inicio",
    "appointmentEnds": "Nuevo fin",
    "confirmAppointmentChange": "Confirmo este cambio y las notificaciones del calendario a los asistentes.",
    "submitAppointmentChange": "Solicitar cambio",
    "appointmentChangeRequested": "Cambio solicitado. Revisa la acción para confirmar el resultado del calendario y del CRM.",
    "APPOINTMENT_CHANGED": "La cita cambió. Actualiza los datos y revisa una nueva solicitud.",
    "APPOINTMENT_ALREADY_CANCELLED": "Esta cita ya fue cancelada.",
    "APPOINTMENT_CALENDAR_REFERENCE_MISSING": "Esta reserva no tiene una referencia de calendario registrada. Revísala directamente con el responsable del calendario.",
    "CALENDAR_CHANGE_UNCONFIRMED": "El cambio del calendario necesita conciliación antes de confirmar el resultado.",
    "newest": "Más recientes",
    "older": "Anteriores",
    "reason": "Motivo",
    "billing": "Facturación y renovaciones",
    "billingNotConfigured": "El operador de la plataforma debe configurar la autoridad de facturación.",
    "billingAuthority": "Autoridad de pago",
    "billingCrm": "Factura y pago registrado en CRM",
    "billingOperator": "Operador de plataforma con comprobante de pago externo",
    "billingAutoRenew": "Las renovaciones se preparan automáticamente; el servicio se activa solo después del pago confirmado.",
    "billingManualRenew": "Las renovaciones se solicitan manualmente.",
    "billingSync": "Actualizar estado de facturación",
    "billingPlan": "Plan de suscripción",
    "billingStarts": "Inicio de renovación",
    "billingConfirmRenewal": "Solicito un período mensual y su facturación.",
    "billingRequestRenewal": "Solicitar renovación",
    "billingUpgrade": "Cambiar a un plan mayor",
    "billingUpgradeHelp": "El plan mayor empieza un periodo mensual propio en el momento de la solicitud y reemplaza al periodo actual cuando se confirma su pago. Desde entonces el asistente dispone de todas las conversaciones del plan nuevo; los días que quedaban del periodo actual no se devuelven.",
    "billingUpgradeRenews": "Las renovaciones automáticas continuarán con el plan nuevo.",
    "billingUpgradePlan": "Plan nuevo",
    "billingPlanConversations": "conversaciones",
    "billingPerMonth": "al mes",
    "billingConfirmUpgrade": "Solicito el cambio de plan y la facturación de su primer mes.",
    "billingRequestUpgrade": "Solicitar cambio de plan",
    "billingLargestPlan": "Este es el plan con más conversaciones. Para más capacidad, coordina con el operador de la plataforma.",
    "billingBeforeTax": "antes de impuestos aplicables",
    "billingInvoice": "Referencia de factura",
    "billingPayment": "Referencia de pago",
    "BILLING_PERIOD_INVALID": "Elige una renovación posterior al período actual. No se pueden comprar períodos vencidos.",
    "BILLING_PERIOD_CONFLICT": "Otra solicitud o renovación ya cubre ese período.",
    "BILLING_UPGRADE_NOT_LARGER": "Elige un plan con más conversaciones que el actual.",
    "BILLING_NOT_CONFIGURED": "El operador de la plataforma debe configurar la autoridad de facturación.",
    "SUBSCRIPTION_PAYMENT_MISMATCH": "El pago no coincide con este período de suscripción.",
    "choose": "Elige un plan",
    "privacy": "Privacidad",
    "privacyScope": "Casos por conversación. Solo propietarios y administradores pueden consultar, exportar o disponer de los datos bloqueados.",
    "privacyBlock": "Registrar solicitud y bloquear",
    "conversationId": "Identificador de la conversación",
    "privacyReason": "Motivo",
    "authorityReference": "Autoridad y evidencia de la solicitud",
    "erasure_request": "Solicitud de supresión",
    "purpose_ended": "Finalidad concluida",
    "processor_contract_ended": "Contrato del encargado concluido",
    "privacyNoCases": "No hay casos en esta página.",
    "nextPage": "Siguiente página",
    "privacyCase": "Caso de privacidad",
    "privacyDeleteAfter": "Disposición permitida desde",
    "privacyDecision": "Decisión de conservación y disposición",
    "privacyCompleted": "Disposición de las copias operativas de Assist completada.",
    "privacyRetained": "Se conservan el registro de auditoría, los totales de facturación y las huellas necesarias para impedir reimportaciones. Los originales del CRM, correo y copias de seguridad tienen sus propios controles de conservación.",
    "privacyDeletedObjects": "Adjuntos eliminados y verificados",
    "privacyRetainedUsage": "Registros de costo conservados",
    "privacyRetainedWindows": "Ventanas facturables conservadas",
    "privacyProfileCleared": "Perfil exclusivo de esta conversación limpiado.",
    "privacySharedProfile": "Los perfiles o consentimientos compartidos se conservan para revisión independiente.",
    "privacyExport": "Exportación para revisión del responsable",
    "privacyExportHelp": "Descarga por sección y página. Continúe hasta el fin de cada sección. Los archivos adjuntos se descargan por separado desde su sección.",
    "privacyExportSection": "Sección",
    "privacyDownloadFirst": "Descargar primera página",
    "privacyDownloadNext": "Descargar siguiente página",
    "privacyExportEnd": "Fin de esta sección.",
    "privacyHolds": "Impedimentos legales",
    "privacyReleased": "Liberado",
    "privacyReleaseReference": "Evidencia que autoriza la liberación",
    "privacyReleaseHold": "Liberar impedimento",
    "privacyHoldBasis": "Fundamento del impedimento legal",
    "privacyAddHold": "Registrar impedimento",
    "privacyDecisionHelp": "Registre la determinación real del responsable. Las fechas y horas corresponden a Perú. No se aplica un plazo genérico a todas las conversaciones.",
    "privacyPurposeEnded": "Finalidad concluida el (Perú)",
    "privacyRetainUntil": "Conservar hasta (Perú)",
    "privacyDecisionBasis": "Fundamento y referencia de la decisión",
    "privacyFinancialClass": "Clasificación financiera",
    "privacySelectClass": "Seleccione la clasificación revisada",
    "not_financial": "No financiera",
    "other_financial": "Otra evidencia financiera",
    "tax_evidence": "Evidencia tributaria",
    "privacyFilingDeadline": "Vencimiento de la declaración tributaria",
    "privacyPrescriptionEnd": "Fin de prescripción determinado (Perú)",
    "privacyTaxDetermination": "Referencia de la determinación tributaria",
    "privacyContractEnded": "El contrato del encargado ha terminado",
    "privacyContractDate": "Fecha de término del contrato (Perú)",
    "privacyControllerReturn": "Evidencia de devolución al responsable",
    "privacyException": "Excepción legal de conservación, cuando corresponda",
    "privacyDownstreamHelp": "Registre las instrucciones aplicables para destinatarios externos. Assist no elimina originales de otros sistemas.",
    "privacyRecipient": "Destinatario",
    "privacyInstruction": "Referencia de instrucciones",
    "privacyRemoveRecipient": "Quitar destinatario",
    "privacyAddRecipient": "Agregar destinatario",
    "privacySaveDecision": "Guardar decisión",
    "privacyDisposalHelp": "Esta operación elimina las copias autorizadas de Assist. Los impedimentos, plazos y operaciones sin resolver se verifican antes de comenzar. Las tandas pendientes pueden continuarse desde este caso.",
    "privacyConfirmDisposal": "Confirmo la disposición de las copias de Assist conforme a la decisión registrada.",
    "privacyContinueDisposal": "Continuar disposición",
    "privacyDispose": "Disponer de los datos autorizados",
    "privacyForbidden": "Esta sección requiere el rol de propietario o administrador.",
    "blocked": "Bloqueado",
    "scheduled": "Con decisión registrada",
    "deleting": "Disposición en curso",
    "PRIVACY_PROCESSING_ACTIVE": "Hay procesamiento o una carga de archivo sin resolver. La disposición está bloqueada.",
    "PRIVACY_EXTERNAL_OPERATIONS_UNRESOLVED": "Hay operaciones o borradores externos sin resolver. Conserve la evidencia y resuelva su resultado antes de disponer de los datos.",
    "PRIVACY_RETENTION_ACTIVE": "El plazo de conservación aún no ha concluido.",
    "PRIVACY_LEGAL_HOLD_ACTIVE": "Un impedimento legal activo impide la disposición.",
    "CONVERSATION_PRIVACY_BLOCKED": "La conversación está bloqueada por privacidad.",
    "EVIDENCE_DELETION_UNCONFIRMED": "No se pudo verificar la eliminación del archivo. El caso permanece abierto para reintentar.",
    "export_conversations": "Datos de la conversación",
    "export_messages": "Transcripción",
    "export_channel_inbox": "Mensajes recibidos",
    "export_assistant_actions": "Acciones",
    "export_channel_outbox": "Mensajes salientes",
    "export_classification_decisions": "Clasificaciones",
    "export_classification_reviews": "Revisiones de clasificación",
    "export_conversation_attachments": "Archivos adjuntos",
    "export_conversation_holds": "Impedimentos operativos",
    "export_collection_followups": "Seguimientos de cobranza",
    "export_usage_events": "Uso y costos",
    "export_model_operations": "Operaciones de modelos",
    "export_interaction_windows": "Ventanas facturables",
    "export_action_executions": "Ejecuciones registradas",
    "memoryTitle": "Memoria del cliente",
    "memoryHelp": "Respuestas y consultas validadas que se aprenden de conversaciones aceptadas. Las consultas obtienen datos actuales. Los mensajes y datos personales no se convierten en memoria compartida.",
    "memoryEnabled": "Usar memoria validada",
    "memoryLearningEnabled": "Aprender candidatos en segundo plano",
    "memoryDailyLimit": "Máximo de trabajos de aprendizaje por día (UTC)",
    "memoryMetrics": "Últimos 30 días",
    "memoryMetricsHelp": "Costo real del modelo y tiempo de procesamiento de respuestas aceptadas. El costo de aprendizaje se muestra por separado. Las consultas pueden ser diferentes: esta comparación no garantiza un ahorro.",
    "memoryCoverage": "Cobertura de memoria",
    "memoryNoMeasurements": "Todavía no hay respuestas aceptadas medidas.",
    "memoryRoute": "Ruta de respuesta",
    "memoryTurns": "Respuestas",
    "memoryCalls": "Llamadas al modelo",
    "memoryCost": "Costo del proveedor",
    "memoryLatency": "Tiempo promedio",
    "memoryLuna": "Interpretación de Luna",
    "memoryLearning": "Trabajos de aprendizaje",
    "memoryEntries": "Entradas de memoria",
    "memoryEmpty": "Todavía no hay candidatos aprendidos.",
    "memoryCurrent": "Fuentes y política vigentes",
    "memoryStale": "Vencida o con fuentes/política modificadas",
    "memoryHits": "Coincidencias",
    "memoryCorrections": "Veces desactivada",
    "memoryExpires": "Vencimiento",
    "memoryInspect": "Revisar respuesta o consulta",
    "memoryRevision": "Revisión de conocimiento / política",
    "memoryDisable": "Desactivar",
    "memoryRestore": "Restaurar versión validada",
    "memoryFirstPage": "Primera página",
    "memoryNextPage": "Página siguiente",
    "export_client_memory_learning": "Trabajos de aprendizaje de memoria",
    "export_client_memory_turns": "Mediciones de uso de memoria",
    "chatPresentation": "Inicio del chat",
    "customChatPresentation": "Personalizar el inicio del chat",
    "chatSubtitle": "Subtítulo del asistente",
    "chatIntroduction": "Orientación inicial",
    "chatSuggestionsHelp": "Las sugerencias preparan un mensaje editable. Solo se muestran cuando la acción requerida está disponible. No deben prometer capacidades que el bot no tenga.",
    "chatSuggestionLabel": "Texto del botón",
    "chatSuggestionMessage": "Mensaje editable",
    "chatSuggestionAction": "Acción requerida",
    "removeChatSuggestion": "Quitar sugerencia",
    "addChatSuggestion": "Agregar sugerencia",
    "currentMode": "Modo actual",
    "humanReasonClassifier": "El clasificador pidió revisión humana para el mensaje que originó esta pausa.",
    "humanReasonCustomer": "El cliente pidió hablar con una persona.",
    "humanReasonOperator": "La conversación está en atención humana. Revisa las pausas y el historial antes de reactivar el asistente.",
    "stoppedReason": "El cliente pidió no recibir más contacto. El asistente no puede reactivarse.",
    "resumeBlockedByHolds": "El asistente no puede reactivarse mientras existan pausas sin resolver. Revisa las pausas de abajo.",
    "latestDecision": "Clasificación del último mensaje",
    "latestDecisionHelp": "Señales detectadas por el clasificador. Una señal de atención humana pausa la respuesta automática de ese mensaje.",
    "noDecision": "Todavía no hay una clasificación registrada.",
    "decisionIntent": "Intención",
    "decisionSignals": "Señales",
    "decisionNoSignals": "Sin señales de riesgo",
    "intent_offering_question": "Consulta de producto",
    "intent_sales": "Interés de compra",
    "intent_appointment": "Cita",
    "intent_account_question": "Consulta de cuenta",
    "intent_payment_claim": "Pago por verificar",
    "intent_dispute": "Reclamo o disputa",
    "intent_payment_proposal": "Propuesta de pago",
    "intent_human_help": "Pide una persona",
    "intent_stop": "Solicita no recibir contacto",
    "intent_other": "Otra",
    "holdPendingTriageHelp": "Este mensaje aún no fue clasificado. Reintenta la clasificación o espera a que el sistema termine.",
    "retryClassification": "Reintentar clasificación",
    "CUSTOMER_OR_ACCOUNT_HOLD_REQUIRES_RESOLUTION": "Hay pausas sin resolver. Revísalas antes de reactivar el asistente.",
    "HOLD_REQUIRES_VERIFIED_ACCOUNT": "La pausa requiere una cuenta verificada y la obligación correcta.",
    "AUTHORITATIVE_CASE_RESOLUTION_REQUIRED": "El sistema de origen debe confirmar el resultado antes de resolver esta pausa.",
    "CASE_RESOLUTION_EVENT_MISMATCH": "El caso no corresponde al mensaje que originó la pausa.",
    "LEDGER_HAS_NOT_RESOLVED_HOLD": "La obligación seleccionada no resuelve esta pausa.",
    "FAILED_UNCLASSIFIED_EVENT_NOT_FOUND": "El mensaje fallido ya fue revisado o no existe.",
    "FAILED_EVENT_NOT_FOUND": "El mensaje fallido ya no está disponible para reintentar.",
    "OPERATOR_MODE_CHANGED": "Cancelado al cambiar el modo del asistente",
    "HUMAN_TAKEOVER": "Cancelado por atención humana",
    "CUSTOMER_HOLD": "Cancelado por una pausa del cliente",
    "NEW_CUSTOMER_MESSAGE": "Reemplazado por un mensaje más reciente del cliente",
    "DELIVERY_HELD": "Retenido por una pausa sin resolver",
    "CONVERSATION_CHANGED": "La conversación cambió antes del envío",
    "ACCOUNT_VERIFICATION_EXPIRED": "La verificación de cuenta venció",
    "SUBSCRIPTION_CAPACITY_UNAVAILABLE": "Sin capacidad disponible en el plan",
    "ACTION_NOT_AVAILABLE_FOR_RECOVERY": "La acción ya no está disponible para recuperación",
    "salesPlaybook": "Estrategia de ventas",
    "salesPlaybookHelp": "Luna adapta su conversación al deseo y a las dudas del comprador para conseguir una llamada o visita que quiera tener. El tipo y horario se configuran en el calendario.",
    "salesEngineEnabled": "Activar estrategia de ventas adaptable",
    "salesPositioning": "Cómo queremos ayudar a comprar",
    "salesMotivations": "Qué buscan los compradores",
    "salesMotivation": "Motivación del comprador",
    "salesDescribeFirst": "Escribe primero la descripción",
    "salesRemove": "Quitar",
    "salesAddMotivation": "Añadir motivación",
    "salesConcerns": "Dudas que podemos resolver",
    "salesConcern": "Duda del comprador",
    "salesAddConcern": "Añadir duda",
    "salesBenefits": "Beneficios respaldados",
    "salesBenefitsHelp": "Relaciona información publicada con lo que le importa al comprador. Luna solo utiliza el beneficio cuando encuentra su evidencia en las fuentes actuales.",
    "salesBenefitMeaning": "Por qué le importa al comprador",
    "salesEvidenceSource": "Dirección de la fuente publicada",
    "salesEvidence": "Texto de la fuente que respalda el beneficio",
    "salesBenefitKind": "Tipo de evidencia",
    "salesFeature": "Característica del proyecto o producto",
    "salesForMotivations": "Útil para estas motivaciones",
    "salesForConcerns": "Resuelve estas dudas",
    "salesAddBenefit": "Añadir beneficio",
    "salesAdviserOutcomes": "Qué gana el comprador con la conversación",
    "salesAdviserOutcomesHelp": "Describe decisiones concretas que el asesor puede ayudar a tomar y a quién le sirven.",
    "salesCallValue": "Resultado útil para el comprador",
    "salesAddOutcome": "Añadir resultado",
    "salesTechniques": "Enfoques de conversación",
    "salesListening": "Escuchar y adaptar",
    "salesImagery": "Ayudar a imaginar su uso",
    "salesSelfPersuasion": "Descubrir sus propias razones",
    "salesComparison": "Comparar lo relevante",
    "salesObjections": "Resolver la duda real",
    "salesProof": "Experiencias documentadas",
    "salesOpportunity": "Oportunidad limitada real",
    "salesPlanning": "Concretar día y hora",
    "salesExcluded": "Afirmaciones que no se deben utilizar (una por línea)",
    "modelSettings": "Modelos",
    "responseModel": "Modelo de respuestas",
    "modelSettingsHelp": "El modelo elegido redacta, revisa y aprende con la personalidad y las reglas de este bot. Jev sigue clasificando. Al publicar también se preparan los mensajes de confirmación y seguimiento con esta personalidad. Los cambios se aplican al publicar; las conversaciones en curso conservan su versión hasta aplicarles la nueva política.",
    "modelDiscoveryHelp": "Solo se pueden elegir modelos compatibles con Assist y disponibles para la clave de OpenAI configurada.",
    "reasoningEffort": "Esfuerzo de razonamiento",
    "reasoningHelp": "Más razonamiento puede aumentar el tiempo de respuesta y el consumo. Medio conserva el comportamiento anterior.",
    "responseProcessingMode": "Velocidad de respuesta en vivo",
    "processingStandard": "Estándar",
    "processingFast": "Fast",
    "responseProcessingModeHelp": "Fast acelera las respuestas a clientes con el mismo modelo y razonamiento. Cuesta el doble por token si OpenAI lo entrega en Fast; las solicitudes que entrega en Estándar se cobran en Estándar. La preparación de mensajes, el aprendizaje y las tareas en segundo plano siguen en Estándar.",
    "responseOutputTokens": "Capacidad de respuesta (tokens)",
    "responseOutputTokensHelp": "Máximo por generación, incluido el razonamiento: 8.000 por defecto, entre 1.024 y 32.000. Da espacio para respuestas completas; no obliga al bot a escribir más. El consumo depende de los tokens que use.",
    "reasoning_none": "Sin razonamiento adicional",
    "reasoning_low": "Bajo",
    "reasoning_medium": "Medio",
    "reasoning_high": "Alto",
    "reasoning_xhigh": "Muy alto",
    "reasoning_max": "Máximo",
    "refreshModels": "Actualizar modelos disponibles",
    "modelUnavailable": "No disponible para esta clave",
    "modelChecking": "Comprobando disponibilidad…",
    "MODEL_DISCOVERY_UNAVAILABLE": "No se pudo consultar a OpenAI o Anthropic. Vuelve a comprobar los modelos disponibles. Tu selección guardada se conserva.",
    "MODEL_DISCOVERY_INVALID": "OpenAI o Anthropic devolvió una lista de modelos no válida. Vuelve a intentarlo.",
    "modelSettingNotOffered": "No disponible en este modelo",
    "ANTHROPIC_NOT_CONFIGURED": "El modelo elegido es de Anthropic y este asistente no tiene una clave de Anthropic. Añádela en Proveedores de IA o elige otro modelo.",
    "BOT_MESSAGES_GENERATION_FAILED": "No se pudieron preparar los mensajes con la personalidad elegida. El bot publicado sigue activo; vuelve a publicar para reintentarlo.",
    "BOT_MESSAGES_INVALID": "El modelo no completó el conjunto de mensajes. El bot publicado sigue activo; vuelve a intentarlo.",
    "BOT_MESSAGE_SERVICES_INVALID": "No se pudieron preparar los nombres de las citas. La versión publicada sigue activa; vuelve a intentarlo.",
    "BOT_MESSAGES_FIELDS_INVALID": "El modelo cambió datos obligatorios de los mensajes. El bot publicado sigue activo; vuelve a intentarlo.",
    "BOT_MESSAGES_REVIEW_FAILED": "Los mensajes generados no conservaron el significado de alguna operación. El bot publicado sigue activo; vuelve a publicar para reintentarlo.",
    "BOT_MESSAGES_NOT_PREPARED": "Falta preparar los mensajes de esta versión del bot. Ejecuta la preparación de mensajes antes de usarla.",
    "RESPONSE_MODEL_UNAVAILABLE": "El modelo elegido no está disponible para las claves configuradas. Actualiza los modelos y elige uno disponible.",
    "leads": "Contactos comerciales",
    "leadsHelp": "Datos confirmados por el cliente y resultado de su solicitud.",
    "leadFrom": "Desde (hora de Perú)",
    "leadThrough": "Hasta (hora de Perú)",
    "leadExport": "Descargar CSV",
    "leadNoData": "No hay solicitudes confirmadas en este período.",
    "leadNext": "Siguientes",
    "leadFirst": "Volver al inicio",
    "leadCustomer": "Cliente",
    "leadContact": "Contacto",
    "leadRequest": "Necesidad y contexto",
    "leadResult": "Resultado",
    "leadExportHelp": "El CSV incluye el período seleccionado completo, hasta 1.000 solicitudes. Para períodos mayores, selecciona fechas más cortas.",
    "LEAD_EXPORT_DATE_RANGE_REQUIRED": "Hay más de 1.000 solicitudes. Selecciona un período más corto para exportar todos sus resultados.",
    "leadDestination": "Guardar solicitudes en",
    "leadAssist": "Assist: panel de contactos y CSV",
    "leadBusiness": "Sistema comercial conectado",
    "saveConfigurationDraft": "Guardar borrador",
    "configurationDraftSaved": "Hay cambios guardados sin publicar. La versión publicada sigue activa.",
    "publishConfigurationDraft": "Publicar borrador guardado",
    "publishingConfiguration": "Publicando…",
    "publishingConfigurationHelp": "Publicando. Si cambió la personalidad o el modelo, preparar los mensajes del asistente puede tardar unos minutos.",
    "configurationPublished": "Publicado. Las conversaciones nuevas usan esta versión; las que ya están abiertas conservan la suya.",
    "liveVersion": "Versión publicada",
    "draftChanges": "El borrador guardado cambia:",
    "draftUnchanged": "El borrador guardado no cambia nada de la versión publicada.",
    "summaryNone": "Ninguno",
    "CONFIGURATION_DRAFT_CONFLICT": "El borrador cambió en otra sesión. Recarga antes de guardar.",
    "CONFIGURATION_INVALID": "Completa o corrige estos campos y guarda el borrador antes de publicar. La versión publicada sigue activa.",
    "CONFIGURATION_PUBLISHED_SINCE_EDIT": "Se publicó otra versión mientras editabas. Recarga para revisar los cambios.",
    "appointmentServices": "Llamadas, visitas y servicios",
    "appointmentServicesHelp": "Cada servicio tiene su propio calendario, duración y horario. Activa únicamente lo que este negocio ofrece.",
    "addAppointmentService": "Añadir servicio",
    "serviceName": "Nombre que verá el cliente",
    "serviceLocation": "Lugar o dirección",
    "serviceAppointment": "Cita para un servicio",
    "APPOINTMENT_SERVICE_REQUIRED": "Indica qué servicio quiere reservar el cliente.",
    "APPOINTMENT_SERVICE_NOT_FOUND": "Este servicio ya no está disponible.",
    "chooseApprovedSource": "Selecciona información aprobada",
    "chooseSourcePassage": "Elige el dato que respalda este beneficio",
    "sourceEvidenceChanged": "El dato guardado ya no coincide con esta fuente. Elige un dato vigente antes de publicar.",
    "businessIdentity": "Negocio y clientes",
    "businessDescription": "¿Qué ofrece este negocio?",
    "businessAudience": "¿A quién atiende?",
    "personalityAndSales": "Personalidad y enfoque comercial",
    "configurationUnsaved": "Hay cambios sin guardar. Guarda el borrador antes de publicarlo.",
    "createClient": "Crear cliente",
    "createClientHelp": "Crea una instalación sin publicar el asistente. Elige el plan contratado y su periodo; luego configura información, citas y canales.",
    "clientLegalName": "Razón social",
    "clientPlan": "Plan mensual contratado",
    "clientChoosePlan": "Selecciona el plan",
    "clientPeriodStarts": "Inicio del periodo (Perú)",
    "clientPeriodEnds": "Fin del periodo, exclusivo (Perú)",
    "INSTALLATION_OPERATOR_REQUIRED": "Tu cuenta no tiene permiso para crear clientes.",
    "INSTALLATION_REQUEST_CONFLICT": "Esta solicitud ya existe con otros datos.",
    "configurationPreview": "Probar borrador",
    "configurationPreviewHelp": "Usa los modelos configurados y las fuentes actuales. Consulta información y horarios reales, pero se detiene antes de guardar solicitudes o hacer reservas. Las pruebas no cuentan como conversaciones de clientes; se registra su consumo de modelos.",
    "previewCustomer": "Cliente de prueba",
    "previewMessage": "Mensaje para probar",
    "previewSend": "Probar mensaje",
    "previewReset": "Reiniciar prueba",
    "previewActionBoundary": "La prueba llegó a una acción que requiere confirmación. No se guardó una solicitud, no se hizo una reserva ni se envió un mensaje. Reinicia para probar otro recorrido.",
    "PREVIEW_REPLY_REQUIRES_REVIEW": "La respuesta no pasó la revisión de fuentes o comunicación. Revisa el borrador y sus fuentes.",
    "PREVIEW_ACTION_UNAVAILABLE": "La acción no está disponible en esta configuración.",
    "exportPublishedConfiguration": "Exportar configuración publicada",
    "productSalesUnavailable": "Ventas de productos: no disponibles hasta conectar un sistema de productos, pedidos y pagos.",
    "qualifiedLeadOutcome": "Guardar solicitudes confirmadas de clientes",
    "appointmentOutcome": "Reservar llamadas, visitas o servicios configurados",
    "productSaleOutcome": "Confirmar pedidos y cobrar por enlace (requiere proveedor; no disponible)",
    "appointmentRequiresLead": "Toda reserva guarda primero la solicitud confirmada del cliente.",
    "configurationSources": "Información y oferta",
    "configurationSourcesHelp": "Aprueba la información de apoyo y conecta fuentes de datos actuales. Guarda primero tus cambios antes de abrir otra sección.",
    "approvedSourceOrigins": "Dominios autorizados para este cliente",
    "approvedSourceOriginsHelp": "Autoriza solo dominios del cliente o de su proveedor. Usa el origen HTTPS exacto, sin rutas. Las autorizaciones de plataforma existentes se administran por separado.",
    "sourceOrigin": "Origen HTTPS de la fuente",
    "approveSourceOrigin": "Autorizar dominio",
    "SOURCE_ORIGIN_INVALID": "Usa solo el origen HTTPS, sin ruta, consulta ni fragmento.",
    "SOURCE_ORIGIN_LIMIT_REACHED": "Se alcanzó el límite de 20 dominios por tipo de fuente.",
    "SALES_APPROACH_REQUIRED": "Configura el enfoque comercial antes de publicar un asistente de ventas.",
    "SALES_EVIDENCE_CHANGED": "Un beneficio comercial ya no coincide con la información publicada. Elige nuevamente el dato vigente antes de publicar.",
    "catalogSettings": "Catálogo",
    "catalogSettingsHelp": "El bot consulta la fuente conectada. Los productos visibles se limitan por los permisos de esa conexión.",
    "catalogType": "Tipo de productos",
    "catalogMaxChatCards": "Máximo de tarjetas por respuesta",
    "catalogSourceDefault": "Usar el tipo indicado por la fuente",
    "catalogProperty": "Inmuebles",
    "catalogGeneral": "Otros productos",
    "catalogLabel": "Nombre de los productos",
    "catalogReferenceTerms": "Palabras para referirse al producto (separadas por comas)",
    "catalogAttributesHelp": "Selecciona los datos públicos que el bot puede usar. Un dato ausente se informa como desconocido.",
    "catalogField": "Campo en la fuente",
    "catalogAttributeLabel": "Nombre del dato",
    "catalogValueType": "Tipo de dato",
    "catalogUnit": "Unidad o moneda (PEN / USD para precios)",
    "catalogType_text": "Texto",
    "catalogType_number": "Número",
    "catalogType_decimal": "Decimal exacto",
    "catalogType_boolean": "Sí / no",
    "catalogType_text_list": "Lista de textos",
    "catalogType_money": "Importe en centavos",
    "catalogRemoveAttribute": "Quitar dato",
    "catalogAddAttribute": "Añadir dato",
    "CATALOG_PROFILE_MISMATCH": "El tipo de catálogo no coincide con la fuente conectada. Selecciona el tipo indicado por la fuente.",
    "CATALOG_CAPABILITY_REQUIRED": "La fuente debe indicar su tipo de catálogo y permitir consultar productos.",
    "CATALOG_PAGES_REQUIRED": "La fuente devuelve productos sin información de paginación. Revisa el contrato del conector.",
    "modelCredentials": "Claves API de los modelos",
    "modelCredentialsHelp": "Elige quién proporciona las claves de OpenAI y Jev para este asistente. Los cambios se aplican de inmediato a las nuevas operaciones de modelos.",
    "modelCredentialSource": "Origen de las claves",
    "modelCredentialPlatform": "Claves de la plataforma",
    "modelCredentialOwn": "Exigir claves propias de este asistente",
    "modelCredentialStrict": "Todos los procesos de modelos usan las claves del asistente. Si faltan o son rechazadas, la operación se detiene; nunca se sustituyen por claves de la plataforma.",
    "openaiApiKey": "Clave API de OpenAI",
    "jevApiKey": "Clave API de Jev",
    "anthropicApiKey": "Clave API de Anthropic (opcional)",
    "anthropicKeyHelp": "Solo la necesitan los asistentes que responden con un modelo Claude. Deja el campo vacío para conservar la clave guardada.",
    "modelKeyStored": "Clave guardada de forma segura. Deja el campo vacío para conservarla o ingresa una nueva.",
    "modelKeyRequired": "Se requiere una clave. Las claves guardadas nunca se muestran.",
    "saveModelCredentials": "Guardar configuración de claves",
    "modelCredentialsSaved": "Configuración de claves guardada.",
    "BOT_MODEL_KEYS_REQUIRED": "Ingresa las claves de OpenAI y Jev antes de exigir claves propias de este asistente.",
    "BOT_MODEL_CREDENTIAL_POLICY_MISSING": "Falta la configuración del origen de las claves de este asistente. Un administrador debe revisar la instalación; no se usarán otras claves.",
    "accountAiProviders": "Proveedores de IA",
    "accountKeysHelp": "Administra las claves de tu cuenta y elige cuáles debe usar cada asistente. Los cambios se aplican a las nuevas operaciones de modelos.",
    "credentialProfiles": "Claves guardadas",
    "addCredentialProfile": "Añadir claves",
    "noCredentialProfiles": "No hay claves propias guardadas. Puedes usar las de la plataforma o añadir las de tu empresa.",
    "credentialsEncrypted": "OpenAI y Jev · Almacenadas cifradas",
    "credentialsEncryptedWithAnthropic": "OpenAI, Jev y Anthropic · Almacenadas cifradas",
    "credentialProfileName": "Nombre para estas claves",
    "replaceSharedKeysHelp": "Deja una clave vacía para conservarla. Reemplazarla afecta a todos los asistentes que usan estas claves.",
    "newSharedKeysHelp": "Añade ambas claves. Después podrás asignarlas a uno o varios asistentes de esta cuenta.",
    "credentialAssignments": "Claves que usa cada asistente",
    "ownKeysRequired": "claves propias obligatorias",
    "setupNavigation": "Configuración del asistente",
    "setupBusiness": "Negocio",
    "setupInformation": "Información",
    "setupVoice": "Voz",
    "setupAppointments": "Personas y citas",
    "setupChannels": "Canales",
    "setupReview": "Probar y publicar",
    "setupBusinessHelp": "Empieza con lo esencial: qué ofrece tu empresa, a quién ayuda y qué quieres que consiga el asistente.",
    "setupInformationHelp": "Conecta información fiable. Los precios y la disponibilidad se consultan en la fuente conectada; los documentos requieren revisión.",
    "setupVoiceHelp": "Describe cómo debe hablar el asistente. Usa tus propias palabras y conserva aquí las reglas que debe respetar.",
    "setupModel": "Modelo",
    "setupModelHelp": "Elige el modelo que redacta las respuestas, cuánto razona y a qué velocidad trabaja. Estos ajustes deciden el tiempo de respuesta y el costo de cada conversación.",
    "setupAppointmentsHelp": "Elige los servicios que el asistente puede reservar y define quién atiende cada uno.",
    "setupChannelsHelp": "Activa dónde atenderás a tus clientes y revisa el mensaje con el que empieza cada conversación.",
    "setupReviewHelp": "Prueba el borrador con preguntas reales. Publica cuando sus respuestas y funciones sean correctas.",
    "edit": "Editar",
    "remove": "Eliminar",
    "home": "Inicio",
    "assistants": "Asistentes",
    "accountSettings": "Cuenta",
    "accountTeam": "Equipo y asesores",
    "help": "Ayuda",
    "workspaceSections": "Secciones del espacio de trabajo",
    "homeHelp": "Revisa lo que necesita atención y continúa tu trabajo.",
    "assistantOverviewHelp": "Configura, revisa y prueba tu asistente antes de publicar cambios.",
    "noUnpublishedDraft": "Sin cambios pendientes de publicación",
    "notPublished": "Aún sin publicar",
    "published": "Publicado",
    "helpIntroduction": "Cada sección tiene una tarea. Empieza por configurar el asistente y vuelve aquí cuando necesites orientación.",
    "helpSetup": "Configurar un asistente",
    "helpSetupBody": "Abre Asistentes → Configurar. Completa negocio, información, voz, personas y citas, y canales. Guarda el borrador; no cambia las respuestas que reciben tus clientes hasta que publiques.",
    "helpDaily": "Atender a tus clientes",
    "helpDailyBody": "En Conversaciones puedes revisar mensajes y tomar el control cuando haga falta. Contactos reúne las solicitudes confirmadas. Atención humana muestra los casos pendientes y su responsable.",
    "helpAccounts": "Administrar la cuenta",
    "helpAccountsBody": "Cuenta reúne claves de IA, equipo, conexiones y uso. Las claves propias pueden asignarse a varios asistentes. Exigir claves propias detiene las operaciones si esas claves fallan.",
    "helpPublishing": "Guardar, probar y publicar",
    "helpPublishingBody": "Guardar conserva un borrador. Probar permite revisar sus respuestas sin cambiar la versión pública. Publicar activa la configuración para conversaciones nuevas. Aplicar la política a conversaciones abiertas es una acción separada que conserva las operaciones pendientes.",
    "ACCOUNT_ACCESS_FORBIDDEN": "Solo los administradores de esta cuenta pueden gestionar esta sección.",
    "CREDENTIAL_PROFILE_IN_USE": "Estas claves todavía están asignadas a un asistente. Cambia esa asignación antes de eliminarlas.",
    "ACCOUNT_CREDENTIAL_LIST_LIMIT": "La cuenta supera el límite de claves o asistentes que admite esta vista. Contacta al administrador de la plataforma.",
    "adviserDirectoryHelp": "Gestiona las personas que atienden a tus clientes. Vincula sus calendarios y autoriza los asistentes que pueden reservar con ellas.",
    "adviserDirectory": "Asesores",
    "addAdviser": "Añadir asesor",
    "editAdviser": "Editar asesor",
    "noAdvisers": "Todavía no has añadido asesores a esta cuenta.",
    "adviserActive": "Disponible para recibir reservas",
    "adviserInactive": "No recibe reservas nuevas",
    "adviserName": "Nombre del asesor",
    "adviserEmail": "Correo del asesor",
    "adviserAcceptsBookings": "Aceptar reservas nuevas",
    "authorizedAssistants": "Asistentes autorizados",
    "adviserGrantHelp": "Solo estos asistentes pueden ofrecer citas con esta persona. Esto no concede acceso al dashboard.",
    "adviserWorkingHours": "Horario de atención",
    "noAdviserHours": "Añade al menos una franja para ofrecer citas. Sin horario no se ofrecen reservas.",
    "weekday": "Día",
    "addWorkingWindow": "Añadir franja horaria",
    "availabilityExceptions": "Excepciones de disponibilidad",
    "availabilityExceptionsHelp": "Una excepción reemplaza el horario habitual de esa fecha. Déjala sin franjas para marcar el día como no disponible.",
    "exceptionDate": "Fecha",
    "unavailableAllDay": "No disponible todo el día",
    "addAvailabilityException": "Añadir fecha especial",
    "saveAdviser": "Guardar asesor",
    "backToAdvisers": "Volver a asesores",
    "adviserCalendars": "Calendarios del asesor",
    "adviserCalendarsHelp": "Todos los calendarios añadidos bloquean horarios ocupados. En cada servicio elegirás el calendario donde se guardan las reservas.",
    "calendarCanBook": "Permite crear reservas",
    "calendarConflictOnly": "Solo consulta de horarios ocupados",
    "selectCalendarAccount": "Selecciona una cuenta conectada",
    "selectCalendar": "Selecciona un calendario",
    "addAdviserCalendar": "Añadir calendario al asesor",
    "connectCalendarAccount": "Conectar otra cuenta de calendario",
    "calendarOAuthHelp": "Esta conexión solicita acceso al calendario. No solicita acceso a tu correo. Conecta únicamente cuentas que estás autorizado a usar.",
    "ADVISER_REVISION_CONFLICT": "Otra persona ha modificado este asesor. Conserva tus cambios y vuelve a abrirlo para comparar antes de guardar.",
    "ADVISER_NOT_ELIGIBLE": "Este asesor no está activo o no está autorizado para el asistente.",
    "ADVISER_CALENDAR_LIMIT": "Un asesor puede usar hasta 20 calendarios.",
    "CALENDAR_ACCOUNT_UNAVAILABLE": "La conexión del calendario no está disponible. Vuelve a conectarla en Cuenta.",
    "CALENDAR_NOT_AVAILABLE": "Este calendario ya no está disponible en la cuenta conectada.",
    "bookingCalendar": "Calendario para las reservas",
    "serviceAdvisers": "Quién atiende este servicio",
    "adviserAssignmentHelp": "Ofrecemos primero la cita más cercana. Si varios asesores están disponibles a la misma hora, repartimos las reservas por turnos. Revisamos todos sus calendarios para evitar cruces.",
    "noEligibleAdvisers": "Todavía no hay asesores habilitados. Un administrador puede añadirlos y autorizar este asistente en Cuenta → Equipo.",
    "selectAdviser": "Selecciona un asesor",
    "bookingRules": "Anticipación y tiempo entre citas",
    "bookingRulesHelp": "Estos límites se combinan con el horario del servicio, el horario de cada asesor y sus calendarios.",
    "noticeMinutes": "Anticipación mínima (minutos)",
    "bufferBeforeMinutes": "Tiempo libre antes (minutos)",
    "bufferAfterMinutes": "Tiempo libre después (minutos)",
    "horizonDays": "Reservar hasta (días desde hoy)",
    "directCalendarHelp": "Este servicio usa una conexión de calendario existente. Para distribuir las reservas, selecciona un equipo de asesores.",
    "useAdviserTeam": "Configurar un equipo de asesores",
    "newService": "Nuevo servicio",
    "serviceWorkingHours": "Cuándo se ofrece este servicio",
    "serviceHoursHelp": "Define las franjas en las que puede empezar y terminar una cita. El asesor también debe estar disponible durante toda la cita y sus tiempos libres.",
    "crmAdviserLinks": "Identidad del asesor en el CRM",
    "crmAdviserLinksHelp": "Vincula a la persona correcta para que las citas del CRM indiquen quién atenderá al cliente. Esta vinculación no cambia el propietario del contacto ni concede acceso a Assist.",
    "crmPerson": "Asesor del CRM",
    "linkCrmAdviser": "Confirmar vínculo con este asesor",
    "unlinkCrmAdviser": "Quitar vínculo",
    "crmLinked": "Vinculado al CRM",
    "crmSelectConnection": "Selecciona el CRM del asistente",
    "crmNoConnections": "Este asistente no tiene un CRM conectado. Conéctalo desde Cuenta → Conexiones.",
    "dashboardAccess": "Acceso al panel",
    "dashboardAccessHelp": "Invita a las personas que administran el negocio o atienden conversaciones. Ser asesor de citas no concede acceso al panel.",
    "invitePerson": "Invitar a una persona",
    "assistantAccess": "Asistentes a los que puede acceder",
    "assistantAccessHelp": "Selecciona cada asistente y el permiso correspondiente. Los permisos de cuenta no dan acceso automático a las conversaciones.",
    "accessRole": "Permiso",
    "accountRole": "Permiso en la cuenta",
    "accountRoleHelp": "Miembro: solo los asistentes seleccionados. Administrador: gestiona claves, conexiones y equipo. Propietario: también administra otros propietarios.",
    "member": "Miembro",
    "assistantAccessOnly": "Solo permisos por asistente",
    "editAccess": "Editar permisos",
    "invitationEmail": "Correo con el que iniciará sesión",
    "invitationSender": "Enviar desde",
    "selectMailbox": "Selecciona un buzón conectado",
    "invitationSenderHelp": "Conecta un buzón de correo en Cuenta → Conexiones para enviar invitaciones.",
    "invitationConfirmation": "Se enviará un enlace válido durante 7 días. La persona debe iniciar sesión con ese correo y aceptar los permisos.",
    "sendInvitation": "Enviar invitación",
    "invitationSent": "El proveedor confirmó el envío de la invitación.",
    "linkAdviserLogin": "Este acceso pertenece al asesor",
    "saveAccess": "Guardar permisos",
    "revokeInvitation": "Revocar invitación",
    "checkInvitationDelivery": "Comprobar envío",
    "expiresAt": "Vence:",
    "invitation_queued": "Pendiente de envío",
    "invitation_preparing": "Preparando el correo",
    "invitation_prepared": "Correo preparado",
    "invitation_sending": "Envío en curso",
    "invitation_sent": "Enviada; pendiente de aceptación",
    "invitation_uncertain": "El proveedor todavía no confirmó el envío",
    "invitation_failed": "No se pudo preparar el envío",
    "invitation_accepted": "Aceptada",
    "invitation_revoked": "Revocada",
    "invitationReview": "Revisa tu invitación",
    "invitationFor": "Invitación para",
    "signedInAs": "Sesión iniciada como",
    "acceptInvitation": "Aceptar estos permisos",
    "useAnotherAccount": "Usar otra cuenta",
    "invitationSignInHelp": "Inicia sesión con el correo de la invitación para continuar.",
    "INVITATION_NOT_AVAILABLE": "La invitación no está disponible o venció. Pide una nueva al administrador.",
    "INVITATION_EMAIL_MISMATCH": "Inicia sesión con el correo al que se envió esta invitación.",
    "INVITATION_ALREADY_PENDING": "Ya existe una invitación vigente para este correo. Revisa su estado debajo.",
    "INVITATION_DELIVERY_UNCONFIRMED": "El envío sigue sin confirmar. Comprueba su estado antes de volver a invitar.",
    "INVITATION_DELIVERY_IN_PROGRESS": "El envío está en curso. Actualiza su estado en unos minutos.",
    "INVITATION_SENDER_REQUIRED": "Selecciona un buzón de correo conectado.",
    "ADVISER_LOGIN_ALREADY_LINKED": "Este acceso ya está vinculado a otro asesor. Un administrador debe revisar el vínculo.",
    "ACCOUNT_OWNER_REQUIRED": "Este cambio requiere un propietario de la cuenta.",
    "accountSettingsHelp": "Administra la cuenta y los recursos compartidos. Los permisos de cada asistente se eligen por separado.",
    "companyAccount": "Cuenta de la empresa",
    "appliesToAssistant": "Asistente que utiliza esta configuración",
    "accountAssistantScopeHelp": "Las conexiones y el consumo pertenecen al asistente seleccionado. Cambiar de asistente no comparte sus datos.",
    "privacyAccountAccessHelp": "Para gestionar datos de clientes necesitas permiso de administrador en este asistente. Solicita ese acceso en Equipo.",
    "ACCOUNT_BOT_SCOPE_INVALID": "Este asistente no pertenece a la cuenta seleccionada.",
    "ACCESS_FORM_UNSAVED": "Guarda los permisos o cancela el formulario antes de cambiar de sección. Las invitaciones solo se envían al pulsar Enviar invitación.",
    "linkExistingLogin": "Vincular una persona que ya tiene acceso",
    "showLinkedMembers": "Ver accesos vinculados a este asesor",
    "INVITATION_ACCESS_CHANGED": "Los permisos actuales difieren de esta invitación. Pide al administrador que revise el acceso y envíe una nueva invitación.",
    "INVITATION_DELIVERY_CLAIM_LOST": "Otro proceso está gestionando el envío. Actualiza el estado antes de reintentar.",
    "previousStep": "Anterior",
    "nextStep": "Continuar",
    "removeWorkingWindow": "Quitar horario",
    "agenda": "Agenda",
    "agendaHelp": "Citas creadas por este asistente, de más recientes a más antiguas. Consultamos cada calendario para mostrar su estado actual. Abre la conversación para cambiar o cancelar una cita.",
    "agendaEmpty": "No hay citas registradas en esta página.",
    "agendaCalendarUnavailable": "No pudimos consultar este calendario. El estado de la cita no está confirmado. Reintenta o revisa la conexión de calendario en Equipo.",
    "agendaRemoved": "El proveedor ya no encuentra esta cita en el calendario.",
    "agendaCheckedAt": "Verificado en el calendario:",
    "agendaSynchronizationRequired": "El calendario confirmó una reserva, pero Assist aún debe completar su registro. Abre la conversación para revisar la operación.",
    "agendaOpenConversation": "Abrir conversación y gestionar cita",
    "agendaOlder": "Ver reservas anteriores",
    "CRM_ADVISER_NOT_ELIGIBLE": "El asesor vinculado ya no está disponible en este CRM. Revisa el vínculo antes de aceptar nuevas citas.",
    "additionalVoiceRules": "Instrucciones adicionales y firma",
    "additionalVoiceRulesHelp": "Usa esta sección solo para reglas que no hayas explicado arriba. Los datos del negocio se gestionan en Información; las reservas, en Personas y citas.",
    "ADVISER_BOOKING_CALENDAR_UNAVAILABLE": "El calendario de reservas del asesor no está disponible. Revisa sus calendarios en Equipo.",
    "ADVISER_CALENDAR_ACCESS_REQUIRED": "Falta acceso a uno de los calendarios del asesor. Vuelve a conectar la cuenta antes de ofrecer horarios.",
    "ADVISER_CRM_LINK_REQUIRED": "Vincula este asesor con una persona del CRM antes de activar reservas para ese sistema.",
    "ADVISER_POOL_UNAVAILABLE": "No hay asesores activos y autorizados para este servicio. Revisa el equipo y sus permisos.",
    "ADVISER_BOT_SCOPE_INVALID": "Uno de los asistentes seleccionados no pertenece a esta empresa. Actualiza la lista y vuelve a guardar.",
    "CRM_ADVISER_DIRECTORY_UNAVAILABLE": "Esta conexión CRM no permite consultar asesores. Habilita esa función en la instalación CRM.",
    "CRM_APPOINTMENT_HOST_UNAVAILABLE": "Esta conexión CRM no permite asignar un asesor a las citas. Habilita esa función en la instalación CRM.",
    "CALENDAR_SLOT_UNAVAILABLE": "Ese horario ya no está disponible. Consulta la agenda y elige otro.",
    "CALENDAR_CONFIGURATION_CHANGED": "La configuración de reservas cambió. Actualiza la página y vuelve a consultar los horarios.",
    "LAST_OWNER_REQUIRED": "Debe quedar al menos un propietario. Asigna otro propietario antes de quitar este acceso.",
    "INVITATION_ALREADY_ACCEPTED": "Esta invitación ya fue aceptada por otra cuenta. Solicita una nueva invitación.",
    "ACCOUNT_MEMBER_NOT_FOUND": "Esta persona ya no tiene acceso a la cuenta. Actualiza la lista.",
    "OFFICE_REAUTHORIZATION_REQUIRED": "La autorización de Google o Microsoft venció. Vuelve a conectar la cuenta.",
    "CONNECTION_RECONNECTION_REQUIRED": "Esta conexión necesita una nueva autorización de Google o Microsoft. Vuelve a conectar la misma cuenta; reactivarla no recupera el acceso.",
    "OFFICE_REQUIRED_PERMISSIONS_MISSING": "La cuenta no concedió los permisos necesarios. Vuelve a conectar y revisa los permisos solicitados.",
    "CONNECTION_DISABLED": "La conexión está desactivada. Actívala o elige otra conexión.",
    "ACCOUNT_INVITATION_LIMIT": "Hay demasiadas invitaciones pendientes. Revoca las que ya no necesites antes de enviar otra.",
    "connectedCalendars": "Cuentas de calendario",
    "connectedCalendarsHelp": "Conecta una cuenta y elige sus calendarios en Equipo y asesores. Cada asesor puede combinar varios calendarios para evitar cruces.",
    "noCalendarAccounts": "Todavía no hay cuentas de calendario conectadas.",
    "calendarReconnectHelp": "La conexión requiere atención. Vuelve a conectar la misma cuenta para recuperar el acceso.",
    "calendarReconnectRequired": "La autorización de una cuenta de calendario venció. El asistente no puede ofrecer ni reservar horarios hasta que la vuelvas a conectar.",
    "disconnectCalendarHelp": "Los asesores que usan esta cuenta no podrán consultar ni modificar sus citas hasta que vuelvas a conectarla. Las citas existentes permanecen en el proveedor.",
    "reconnectCalendar": "Volver a conectar",
    "disconnectCalendar": "Desconectar",
    "confirmDisconnectCalendar": "Confirmar desconexión",
    "CREDENTIAL_FORM_UNSAVED": "Guarda las claves o cancela la edición antes de cambiar de sección.",
    "ADVISER_FORM_INVALID": "Completa los datos del asesor y corrige los campos indicados. Las franjas horarias deben terminar después de empezar y no pueden superponerse.",
    "assistantAdministration": "Administración del asistente"
  },
  "en": {
    "product": "Cryptology Assist",
    "workspace": "Workspace",
    "inbox": "Conversations",
    "configuration": "Assistant",
    "knowledge": "Knowledge",
    "connections": "Connections",
    "usage": "Usage",
    "signIn": "Sign in to continue",
    "SIGN_IN_REQUIRED": "Your session has ended. Sign in to continue.",
    "noIdentityProviders": "No sign-in provider is configured. Contact your administrator.",
    "google": "Continue with Google",
    "microsoft": "Continue with Microsoft",
    "signOut": "Sign out",
    "selectBot": "Select an assistant",
    "noBots": "No assistants have been assigned to your account yet.",
    "accountId": "Your account ID",
    "loading": "Loading…",
    "retry": "Retry",
    "error": "The request could not be completed.",
    "empty": "No conversations yet.",
    "selectConversation": "Select a conversation",
    "chat": "Web chat",
    "email": "Email",
    "customer": "Customer",
    "assistant": "Assistant",
    "operator": "Operator",
    "automatic": "Automatic",
    "human": "Human assistance",
    "stopped": "Contact stopped",
    "takeOver": "Take over",
    "resume": "Resume assistant",
    "stop": "Stop contact",
    "send": "Send reply",
    "reply": "Your reply",
    "draft": "Draft",
    "approve": "Approve and send",
    "cancel": "Discard",
    "holds": "Follow-up holds",
    "actions": "Actions",
    "attachments": "Files",
    "download": "Download",
    "reviewApprove": "Mark reviewed",
    "reviewReject": "Reject file",
    "verified": "Account verified",
    "unverified": "Account not verified",
    "save": "Save",
    "saved": "Saved",
    "name": "Assistant name",
    "businessName": "Business name",
    "locale": "Language",
    "formality": "Style",
    "formal": "Formal",
    "conversational": "Conversational",
    "personality": "Personality and voice",
    "personalityHelp": "Describe the assistant's warmth, pace, and brand expressions. This does not change facts, permissions, or confirmation rules.",
    "instructions": "Communication instructions",
    "signature": "Email signature",
    "capabilities": "Outcomes and functions",
    "offerings": "Explain products and services",
    "sales": "Sales and appointments",
    "collections": "Collections",
    "channels": "Channels",
    "chatOrigins": "Authorized chat websites (one per line)",
    "enableChat": "Enable chat",
    "enableEmail": "Enable email",
    "emailMode": "Email replies",
    "draftMode": "Review before sending",
    "automaticMode": "Send validated replies",
    "calendar": "Appointment calendar",
    "noCalendar": "No calendar",
    "calendarAccount": "Calendar account",
    "calendarChoice": "Calendar",
    "appointmentKind": "Appointment type",
    "siteVisit": "On-site visit",
    "salesCall": "Sales call",
    "timezone": "Time zone",
    "duration": "Appointment length (minutes)",
    "workingDays": "Working days",
    "opensAt": "From",
    "closesAt": "Until",
    "closed": "Closed",
    "businessConnection": "Catalog and current-data source",
    "noBusinessConnection": "No connection",
    "configurationHelp": "Describe the business, choose its outcomes and configure how it talks. Save a draft, preview it and publish when ready.",
    "connectGoogle": "Connect Gmail and Google Calendar",
    "connectMicrosoft": "Connect Microsoft 365 and Outlook Calendar",
    "mailboxes": "Connected accounts",
    "lastSync": "Last synchronization",
    "notSynced": "No synchronization recorded",
    "disable": "Disconnect",
    "enable": "Re-enable connection",
    "businessSystems": "Catalog, sales, and receivables",
    "provider": "Provider",
    "endpoint": "Connector address",
    "credential": "Connector credential",
    "connect": "Validate and connect",
    "external": "External system",
    "knowledgeHelp": "Publish verified content. Every answer retains the source and version used.",
    "source": "Source",
    "sourceType": "Source type",
    "content": "Verified content",
    "publish": "Review and publish",
    "noKnowledge": "No published sources.",
    "website": "Website",
    "document": "Document",
    "manual": "Original content",
    "approved_chat_learning": "Reviewed learning",
    "status": "Status",
    "subscription": "Subscription",
    "period": "Period",
    "conversationsUsed": "Conversations used",
    "planPeriodEnds": "The period ends",
    "planCapacityLow": "The plan has few conversations left in this period. When they run out, the assistant stops answering new customers.",
    "planCapacityExhausted": "The assistant is not answering new customers: the plan has no conversations left in this period.",
    "planCapacityExhaustedHelp": "Customers who wrote in the last 24 hours still get replies.",
    "planCapacityInactive": "The assistant is not answering new customers: the subscription has no active period.",
    "planCapacityOpen": "View usage and plan",
    "included": "Included in plan",
    "monthlyPrice": "Monthly price",
    "modelUsage": "Model usage",
    "model": "Model",
    "operations": "Operations",
    "inputTokens": "Input tokens",
    "cachedTokens": "Cached tokens",
    "outputTokens": "Output tokens",
    "providerCost": "Provider cost",
    "unpriced": "Operations without confirmed cost",
    "noUsage": "No model operations have been recorded in this period.",
    "confirmationTitle": "Review your request",
    "confirmationHelp": "Confirm these details before continuing.",
    "confirm": "Confirm request",
    "confirmationSent": "Your confirmation has been recorded. You will receive the result when the system completes the operation.",
    "invalidLink": "This confirmation link is invalid or expired.",
    "lead": "Sales request",
    "appointment": "Appointment",
    "paymentProposal": "Payment proposal",
    "amount": "Amount",
    "date": "Date",
    "reference": "Reference",
    "resolve": "Resolve hold",
    "resolutionNote": "Review outcome",
    "loadMore": "Load older conversations",
    "client": "Customer",
    "role": "Permission",
    "team": "Team access",
    "grant": "Save access",
    "owner": "Owner",
    "admin": "Administrator",
    "viewer": "Read only",
    "identityHelp": "Share your account ID with the assistant administrator to receive access.",
    "connectionHelp": "Authorize each mailbox and select a calendar in the assistant configuration.",
    "models": "Jev · Configurable Luna",
    "refresh": "Refresh",
    "request": "Request",
    "acknowledgement": "System acknowledgement",
    "available": "Available",
    "noConnections": "No connected mailboxes.",
    "embed": "Install chat",
    "embedHelp": "Use this module on an authorized website.",
    "copy": "Copy",
    "approved": "Reviewed",
    "quarantined": "Awaiting review",
    "rejected": "Rejected",
    "pending": "Pending",
    "accepted": "Accepted by the system",
    "confirmed": "Confirmed",
    "failed": "Failed",
    "cancelled": "Cancelled",
    "reconciliation_required": "Reconciliation required",
    "awaiting_confirmation": "Awaiting customer confirmation",
    "executing": "Processing",
    "ready": "Connected",
    "syncing": "Syncing",
    "disabled": "Disconnected",
    "active": "Active",
    "installing": "Being configured",
    "payment_claim": "Payment to verify",
    "dispute": "Dispute",
    "human_hold": "Human review",
    "opt_out": "Do not contact request",
    "pending_triage": "Message awaiting classification",
    "source_unavailable": "Source unavailable",
    "notes": "Notes",
    "editRole": "Change role",
    "revoke": "Remove access",
    "mailboxIdentifier": "Mailbox identifier",
    "approvedReplies": "Approved answers",
    "approvedReplyHelp": "Review answers to static questions and their exact paraphrases before use. Add one question per line. These answers are invalidated when knowledge or configuration changes. Prices, balances and availability always require a live source.",
    "noQuestion": "Question not recorded",
    "questions": "Questions and approved paraphrases",
    "answer": "Reviewed answer",
    "expires": "Expires (your local time)",
    "mailImportFailures": "Messages requiring import review",
    "mailImportHelp": "These source messages could not be imported. Other messages continue to sync. Review the error in the source mailbox, then retry. Retrying replays the source page safely without duplicating conversations.",
    "serviceUnavailable": "The service did not return a valid response. Please try again or contact your administrator.",
    "caseId": "Reviewed case in the source system",
    "verifyAccount": "Verify my account",
    "verifyAccountHelp": "Verify access to discuss your account in this email conversation. If you did not request this link, close this page.",
    "accountVerifiedHelp": "Account verified. Reply to the email to continue. If your access expires, request a new link in that conversation.",
    "checkDelivery": "Check provider delivery status",
    "quality": "Quality",
    "qualityHelp": "Independently label actual messages. Automatic email requires 100 reviewed conversations, 20 positives per required signal, 95% precision and no missed positives. Opt-out and human help are always required; claims and disputes are also required for collections. All four signals are measured. Until passing, an operator reviews every email. This does not assess writing quality.",
    "qualityPassed": "Classifier evaluation passed. Client review of wording and live acceptance are still required.",
    "qualityReviewRequired": "Generated email requires operator review.",
    "qualityConversations": "Conversations reviewed",
    "qualityMessages": "Messages reviewed",
    "qualitySignal": "Signal",
    "qualityPositive": "Positive conversations",
    "qualityFalsePositive": "False alarms",
    "qualityMissed": "Missed signals",
    "qualityPaymentClaim": "Claims a payment was made",
    "qualityDispute": "Disputes the debt or amount",
    "qualityStop": "Requests no further contact",
    "qualityHuman": "Requires human assistance",
    "selectAnswer": "Select an answer",
    "yes": "Yes",
    "no": "No",
    "searchConversation": "Customer email or conversation ID",
    "search": "Search",
    "needsAttention": "Needs attention",
    "assignedToMe": "Assigned to me",
    "firstPage": "First page",
    "assignee": "Responsible operator",
    "reviewDeadline": "Review deadline",
    "assign": "Assign review",
    "importKnowledge": "Import a source",
    "importKnowledgeHelp": "Fetch an authorized website page, or upload a PDF, text, Markdown or HTML document up to 2 MB. Review the extracted text before publishing.",
    "sourceDocument": "Document (leave empty to fetch the URL)",
    "captureSource": "Read source",
    "reviewImportedSource": "Confirm that the complete extracted content is correct and approved for customer answers.",
    "revokeKnowledge": "Revoke source",
    "adoptPolicy": "Apply published policy to open conversations",
    "adoptPolicyHelp": "Apply the published profile to existing conversations only when no pending replies, confirmations or uncertain operations would be affected. Existing work is preserved. Changing a connected source or appointment service requires a new conversation.",
    "adoptionApplied": "Conversations updated",
    "adoptionKept": "Conversations kept on their previous version",
    "calendarConfirmed": "Booking confirmed by calendar",
    "recoveryAttempts": "Recovery attempts",
    "reconcileAction": "Check and reconcile outcome",
    "retryRead": "Read source again",
    "holdReviewAction": "Review action",
    "createReviewCase": "Create review case in source system",
    "correctFalsePositive": "Correct false positive",
    "caseHoldRetained": "The case is linked to this message. The hold stays active until the source system confirms the review outcome.",
    "falsePositiveRule": "Review the original message and explain why this signal is incorrect. This is allowed only when no case exists. Opt-out preferences remain in force.",
    "qualityRequirement": "Requirement for enabled tasks",
    "qualityRequired": "Required",
    "qualityMeasuredOnly": "Measured; required when collections is enabled",
    "readiness": "Installation diagnostics",
    "readinessHelp": "Check the published configuration, subscription period, source access, mailbox identity, calendar permission and classifier reviews. These read-only checks do not replace real sales, payment, language or delivery acceptance. Shared-mailbox ownership must also be agreed with other applications.",
    "runDiagnostics": "Run checks",
    "diagnosticArea": "Area",
    "diagnosticResult": "Result",
    "diagnosticNextStep": "Open settings",
    "diagnosticPassed": "Check passed",
    "diagnosticBlocked": "Action required",
    "diagnosticReview": "Independent review needed",
    "diagnosticCapacityLow": "Few conversations left",
    "diagnosticDisabled": "Not enabled",
    "authoritativeResults": "Source results",
    "handoffOperations": "Human handoff",
    "handoffPolicyMissing": "Configure assignees and a response deadline to activate human handoff alerts and escalation.",
    "initialAssignee": "Initial assignee",
    "escalationAssignee": "Escalation assignee",
    "responseMinutes": "Response deadline (minutes)",
    "overdueHandoffs": "Overdue requests assigned to you",
    "noHandoffAlerts": "You have no pending alerts.",
    "acknowledgeAlert": "Acknowledge alert",
    "openConversation": "Open conversation",
    "HANDOFF_ASSIGNEE_NOT_AUTHORIZED": "Select an authorized assignee for this assistant.",
    "HANDOFF_ESCALATION_NOT_CONFIGURED": "Configure an authorized escalation assignee.",
    "selectAssignee": "Select assignee",
    "openHandoffAlerts": "Review overdue requests",
    "saveHandoffPolicy": "Save handoff settings",
    "HANDOFF_POLICY_MEMBER_REQUIRED": "Update handoff assignees before removing this access.",
    "appointments": "Appointments",
    "noAppointments": "No appointments have been booked in this conversation.",
    "appointmentCancelled": "Cancelled in the calendar.",
    "appointmentChange": "Change appointment",
    "rescheduleAppointment": "Reschedule appointment",
    "cancelAppointment": "Cancel appointment",
    "appointmentLocalTime": "Enter the new times in your device’s local timezone.",
    "appointmentStarts": "New start",
    "appointmentEnds": "New end",
    "confirmAppointmentChange": "I confirm this change and the calendar notifications to attendees.",
    "submitAppointmentChange": "Request change",
    "appointmentChangeRequested": "Change requested. Review the action below for provider and CRM confirmation.",
    "APPOINTMENT_CHANGED": "The appointment changed. Refresh it and review a new request.",
    "APPOINTMENT_ALREADY_CANCELLED": "This appointment has already been cancelled.",
    "APPOINTMENT_CALENDAR_REFERENCE_MISSING": "This booking has no recorded calendar reference. Review it directly with its calendar owner.",
    "CALENDAR_CHANGE_UNCONFIRMED": "The calendar change needs reconciliation before its result can be confirmed.",
    "newest": "Newest",
    "older": "Older",
    "reason": "Reason",
    "billing": "Billing and renewals",
    "billingNotConfigured": "The platform operator must configure the billing authority.",
    "billingAuthority": "Payment authority",
    "billingCrm": "CRM invoice and recorded payment",
    "billingOperator": "Platform operator with external payment evidence",
    "billingAutoRenew": "Renewal requests are prepared automatically; service activates only after confirmed payment.",
    "billingManualRenew": "Renewal requests are prepared manually.",
    "billingSync": "Refresh billing status",
    "billingPlan": "Subscription plan",
    "billingStarts": "Renewal starts",
    "billingConfirmRenewal": "I request one monthly period and its billing.",
    "billingRequestRenewal": "Request renewal",
    "billingUpgrade": "Change to a larger plan",
    "billingUpgradeHelp": "The larger plan starts a monthly period of its own at the moment of the request and replaces the current period when its payment is confirmed. From then on the assistant has all conversations of the new plan; the days left of the current period are not refunded.",
    "billingUpgradeRenews": "Automatic renewals will continue with the new plan.",
    "billingUpgradePlan": "New plan",
    "billingPlanConversations": "conversations",
    "billingPerMonth": "a month",
    "billingConfirmUpgrade": "I request the change of plan and the billing of its first month.",
    "billingRequestUpgrade": "Request change of plan",
    "billingLargestPlan": "This is the plan with the most conversations. For more capacity, arrange it with the platform operator.",
    "billingBeforeTax": "before applicable tax",
    "billingInvoice": "Invoice reference",
    "billingPayment": "Payment reference",
    "BILLING_PERIOD_INVALID": "Choose a renewal period after the current period. Expired periods cannot be purchased.",
    "BILLING_PERIOD_CONFLICT": "Another request or renewal already covers that period.",
    "BILLING_UPGRADE_NOT_LARGER": "Choose a plan with more conversations than the current one.",
    "BILLING_NOT_CONFIGURED": "The platform operator must configure the billing authority.",
    "SUBSCRIPTION_PAYMENT_MISMATCH": "The payment does not match this subscription period.",
    "choose": "Choose a plan",
    "privacy": "Privacy",
    "privacyScope": "Conversation-specific cases. Only owners and administrators can access, export or dispose of blocked data.",
    "privacyBlock": "Record request and block",
    "conversationId": "Conversation ID",
    "privacyReason": "Reason",
    "authorityReference": "Request authority and evidence",
    "erasure_request": "Erasure request",
    "purpose_ended": "Processing purpose ended",
    "processor_contract_ended": "Processor contract ended",
    "privacyNoCases": "No cases on this page.",
    "nextPage": "Next page",
    "privacyCase": "Privacy case",
    "privacyDeleteAfter": "Disposal permitted from",
    "privacyDecision": "Retention and disposal decision",
    "privacyCompleted": "Disposal of Assist operational copies completed.",
    "privacyRetained": "Audit records, billing totals and replay-prevention fingerprints remain. CRM originals, mailbox originals and backups have separate retention controls.",
    "privacyDeletedObjects": "Attachments deleted and verified",
    "privacyRetainedUsage": "Cost records retained",
    "privacyRetainedWindows": "Billable windows retained",
    "privacyProfileCleared": "Profile used only by this conversation cleared.",
    "privacySharedProfile": "Shared profiles or consents remain for separate review.",
    "privacyExport": "Export for controller review",
    "privacyExportHelp": "Download each section page by page until its end. Download attachment files separately from the attachments section.",
    "privacyExportSection": "Section",
    "privacyDownloadFirst": "Download first page",
    "privacyDownloadNext": "Download next page",
    "privacyExportEnd": "End of this section.",
    "privacyHolds": "Legal holds",
    "privacyReleased": "Released",
    "privacyReleaseReference": "Evidence authorizing release",
    "privacyReleaseHold": "Release hold",
    "privacyHoldBasis": "Legal hold basis",
    "privacyAddHold": "Record hold",
    "privacyDecisionHelp": "Record the controller’s actual determination. Dates and times use Peru time. No blanket retention period applies to every conversation.",
    "privacyPurposeEnded": "Purpose ended at (Peru)",
    "privacyRetainUntil": "Retain until (Peru)",
    "privacyDecisionBasis": "Decision basis and reference",
    "privacyFinancialClass": "Financial classification",
    "privacySelectClass": "Select the reviewed classification",
    "not_financial": "Not financial",
    "other_financial": "Other financial evidence",
    "tax_evidence": "Tax evidence",
    "privacyFilingDeadline": "Tax filing deadline",
    "privacyPrescriptionEnd": "Determined prescription end (Peru)",
    "privacyTaxDetermination": "Tax determination reference",
    "privacyContractEnded": "The processor contract has ended",
    "privacyContractDate": "Contract end (Peru)",
    "privacyControllerReturn": "Evidence of return to the controller",
    "privacyException": "Statutory retention exception, if applicable",
    "privacyDownstreamHelp": "Record applicable instructions for downstream recipients. Assist does not delete originals in other systems.",
    "privacyRecipient": "Recipient",
    "privacyInstruction": "Instruction reference",
    "privacyRemoveRecipient": "Remove recipient",
    "privacyAddRecipient": "Add recipient",
    "privacySaveDecision": "Save decision",
    "privacyDisposalHelp": "This operation deletes authorized Assist copies. Holds, retention dates and unresolved operations are checked before it starts. Pending batches can be continued from this case.",
    "privacyConfirmDisposal": "I confirm disposal of Assist copies under the recorded decision.",
    "privacyContinueDisposal": "Continue disposal",
    "privacyDispose": "Dispose of authorized data",
    "privacyForbidden": "This section requires the owner or administrator role.",
    "blocked": "Blocked",
    "scheduled": "Decision recorded",
    "deleting": "Disposal in progress",
    "PRIVACY_PROCESSING_ACTIVE": "Processing or an unresolved upload remains. Disposal is blocked.",
    "PRIVACY_EXTERNAL_OPERATIONS_UNRESOLVED": "External operations or drafts remain unresolved. Preserve the evidence and resolve their outcome before disposal.",
    "PRIVACY_RETENTION_ACTIVE": "The retention period has not ended.",
    "PRIVACY_LEGAL_HOLD_ACTIVE": "An active legal hold prevents disposal.",
    "CONVERSATION_PRIVACY_BLOCKED": "The conversation is blocked for privacy.",
    "EVIDENCE_DELETION_UNCONFIRMED": "Attachment deletion could not be verified. The case remains open for retry.",
    "export_conversations": "Conversation details",
    "export_messages": "Transcript",
    "export_channel_inbox": "Received messages",
    "export_assistant_actions": "Actions",
    "export_channel_outbox": "Outgoing messages",
    "export_classification_decisions": "Classifications",
    "export_classification_reviews": "Classification reviews",
    "export_conversation_attachments": "Attachments",
    "export_conversation_holds": "Operational holds",
    "export_collection_followups": "Collections follow-ups",
    "export_usage_events": "Usage and costs",
    "export_model_operations": "Model operations",
    "export_interaction_windows": "Billable windows",
    "export_action_executions": "Recorded executions",
    "memoryTitle": "Client memory",
    "memoryHelp": "Validated answers and search plans learned from accepted conversations. Catalog plans fetch current data. Customer transcripts and personal details are not shared memory.",
    "memoryEnabled": "Use validated memory",
    "memoryLearningEnabled": "Learn new candidates in the background",
    "memoryDailyLimit": "Maximum learning jobs per day (UTC)",
    "memoryMetrics": "Last 30 days",
    "memoryMetricsHelp": "Actual model cost and processing time for accepted replies. Learning cost is separate. Different question mixes mean these cohorts are not a guaranteed savings comparison.",
    "memoryCoverage": "Memory coverage",
    "memoryNoMeasurements": "No accepted replies measured yet.",
    "memoryRoute": "Answer route",
    "memoryTurns": "Replies",
    "memoryCalls": "Model calls",
    "memoryCost": "Provider cost",
    "memoryLatency": "Average processing time",
    "memoryLuna": "Luna interpretation",
    "memoryLearning": "Learning jobs",
    "memoryEntries": "Memory entries",
    "memoryEmpty": "No candidates learned yet.",
    "memoryCurrent": "Current sources and policy",
    "memoryStale": "Expired or sources/policy changed",
    "memoryHits": "Matches",
    "memoryCorrections": "Times disabled",
    "memoryExpires": "Expires",
    "memoryInspect": "Inspect answer or query plan",
    "memoryRevision": "Knowledge / policy revision",
    "memoryDisable": "Disable",
    "memoryRestore": "Restore validated version",
    "memoryFirstPage": "First page",
    "memoryNextPage": "Next page",
    "export_client_memory_learning": "Memory learning jobs",
    "export_client_memory_turns": "Memory routing measurements",
    "chatPresentation": "Chat introduction",
    "customChatPresentation": "Customize chat introduction",
    "chatSubtitle": "Assistant subtitle",
    "chatIntroduction": "Starting guidance",
    "chatSuggestionsHelp": "Suggestions prepare an editable message and appear only when the required action is available. They must not promise unsupported capabilities.",
    "chatSuggestionLabel": "Button label",
    "chatSuggestionMessage": "Editable message",
    "chatSuggestionAction": "Required action",
    "removeChatSuggestion": "Remove suggestion",
    "addChatSuggestion": "Add suggestion",
    "currentMode": "Current mode",
    "humanReasonClassifier": "The classifier requested human review for the message that caused this hold.",
    "humanReasonCustomer": "The customer asked for a person.",
    "humanReasonOperator": "This conversation is in human mode. Review its holds and history before resuming the assistant.",
    "stoppedReason": "The customer asked not to be contacted again. The assistant cannot resume.",
    "resumeBlockedByHolds": "The assistant cannot resume while unresolved holds remain. Review the holds below.",
    "latestDecision": "Latest message classification",
    "latestDecisionHelp": "Signals detected by the classifier. A human-attention signal pauses the automatic reply for that message.",
    "noDecision": "No classification has been recorded yet.",
    "decisionIntent": "Intent",
    "decisionSignals": "Signals",
    "decisionNoSignals": "No risk signals",
    "intent_offering_question": "Product question",
    "intent_sales": "Buying interest",
    "intent_appointment": "Appointment",
    "intent_account_question": "Account question",
    "intent_payment_claim": "Payment to verify",
    "intent_dispute": "Dispute",
    "intent_payment_proposal": "Payment proposal",
    "intent_human_help": "Requests a person",
    "intent_stop": "Requests no further contact",
    "intent_other": "Other",
    "holdPendingTriageHelp": "This message has not been classified yet. Retry the classification or wait for the system to finish.",
    "retryClassification": "Retry classification",
    "CUSTOMER_OR_ACCOUNT_HOLD_REQUIRES_RESOLUTION": "Unresolved holds remain. Review them before resuming the assistant.",
    "HOLD_REQUIRES_VERIFIED_ACCOUNT": "This hold requires a verified account and the correct obligation.",
    "AUTHORITATIVE_CASE_RESOLUTION_REQUIRED": "The source system must confirm the outcome before this hold can be resolved.",
    "CASE_RESOLUTION_EVENT_MISMATCH": "The case does not match the message that created this hold.",
    "LEDGER_HAS_NOT_RESOLVED_HOLD": "The selected obligation does not resolve this hold.",
    "FAILED_UNCLASSIFIED_EVENT_NOT_FOUND": "The failed message was already reviewed or does not exist.",
    "FAILED_EVENT_NOT_FOUND": "The failed message is no longer available for retry.",
    "OPERATOR_MODE_CHANGED": "Cancelled when the assistant mode changed",
    "HUMAN_TAKEOVER": "Cancelled by human assistance",
    "CUSTOMER_HOLD": "Cancelled by a customer hold",
    "NEW_CUSTOMER_MESSAGE": "Replaced by a newer customer message",
    "DELIVERY_HELD": "Held by an unresolved pause",
    "CONVERSATION_CHANGED": "The conversation changed before delivery",
    "ACCOUNT_VERIFICATION_EXPIRED": "Account verification expired",
    "SUBSCRIPTION_CAPACITY_UNAVAILABLE": "No plan capacity available",
    "ACTION_NOT_AVAILABLE_FOR_RECOVERY": "The action is no longer available for recovery",
    "salesPlaybook": "Sales strategy",
    "salesPlaybookHelp": "Luna adapts to the buyer’s goals and concerns to earn a wanted call or visit. Configure its type and hours in the calendar.",
    "salesEngineEnabled": "Enable adaptive sales strategy",
    "salesPositioning": "How we help the buyer",
    "salesMotivations": "What buyers want",
    "salesMotivation": "Buyer motivation",
    "salesDescribeFirst": "Describe this first",
    "salesRemove": "Remove",
    "salesAddMotivation": "Add motivation",
    "salesConcerns": "Concerns we can address",
    "salesConcern": "Buyer concern",
    "salesAddConcern": "Add concern",
    "salesBenefits": "Supported benefits",
    "salesBenefitsHelp": "Connect published information to what matters to the buyer. Luna uses the benefit only when its evidence is present in current sources.",
    "salesBenefitMeaning": "Why it matters to the buyer",
    "salesEvidenceSource": "Published source address",
    "salesEvidence": "Source text supporting the benefit",
    "salesBenefitKind": "Evidence type",
    "salesFeature": "Project or product feature",
    "salesForMotivations": "Useful for these motivations",
    "salesForConcerns": "Addresses these concerns",
    "salesAddBenefit": "Add benefit",
    "salesAdviserOutcomes": "What the buyer gains from the conversation",
    "salesAdviserOutcomesHelp": "Describe concrete decisions the adviser can help with and who benefits.",
    "salesCallValue": "Useful buyer outcome",
    "salesAddOutcome": "Add outcome",
    "salesTechniques": "Conversation approaches",
    "salesListening": "Listen and adapt",
    "salesImagery": "Imagine personal use",
    "salesSelfPersuasion": "Discover personal reasons",
    "salesComparison": "Compare what matters",
    "salesObjections": "Resolve the actual concern",
    "salesProof": "Documented experiences",
    "salesOpportunity": "Genuine limited opportunity",
    "salesPlanning": "Agree a day and time",
    "salesExcluded": "Claims not to use (one per line)",
    "modelSettings": "Models",
    "responseModel": "Response model",
    "modelSettingsHelp": "The selected model writes, reviews and learns using this bot’s personality and rules. Jev keeps classifying. Publishing also prepares confirmation and progress messages in this voice. Changes take effect on publication; ongoing conversations keep their version until you apply the new policy to them.",
    "modelDiscoveryHelp": "Choose from models compatible with Assist and available to the configured OpenAI key.",
    "reasoningEffort": "Reasoning effort",
    "reasoningHelp": "More reasoning can increase response time and token usage. Medium preserves the previous behavior.",
    "responseProcessingMode": "Live response speed",
    "processingStandard": "Standard",
    "processingFast": "Fast",
    "responseProcessingModeHelp": "Fast speeds up customer replies with the same model and reasoning. Tokens cost twice as much when OpenAI delivers Fast; requests delivered on Standard are billed at Standard rates. Message preparation, learning and background tasks stay on Standard.",
    "responseOutputTokens": "Response capacity (tokens)",
    "responseOutputTokensHelp": "Maximum per generation, including reasoning: 8,000 by default, from 1,024 to 32,000. Allows complete answers without asking the bot to write more. Usage depends on the tokens actually used.",
    "reasoning_none": "No additional reasoning",
    "reasoning_low": "Low",
    "reasoning_medium": "Medium",
    "reasoning_high": "High",
    "reasoning_xhigh": "Very high",
    "reasoning_max": "Maximum",
    "refreshModels": "Refresh available models",
    "modelUnavailable": "Unavailable for this key",
    "modelSettingNotOffered": "Not offered by this model",
    "modelChecking": "Checking availability…",
    "MODEL_DISCOVERY_UNAVAILABLE": "Could not reach OpenAI or Anthropic. Check available models again. Your saved selection is preserved.",
    "MODEL_DISCOVERY_INVALID": "OpenAI or Anthropic returned an invalid model list. Please retry.",
    "BOT_MESSAGES_GENERATION_FAILED": "Could not prepare messages in the selected voice. The published bot remains active; publish again to retry.",
    "BOT_MESSAGES_INVALID": "The model did not complete the message set. The published bot remains active; please retry.",
    "BOT_MESSAGE_SERVICES_INVALID": "Could not prepare the appointment service labels. The published version remains active; please retry.",
    "BOT_MESSAGES_FIELDS_INVALID": "The model changed required message fields. The published bot remains active; please retry.",
    "BOT_MESSAGES_REVIEW_FAILED": "The generated messages did not preserve an operation's meaning. The published bot remains active; publish again to retry.",
    "BOT_MESSAGES_NOT_PREPARED": "This bot version has no prepared messages. Run message preparation before using it.",
    "RESPONSE_MODEL_UNAVAILABLE": "The selected model is unavailable to the configured keys. Refresh models and choose an available one.",
    "ANTHROPIC_NOT_CONFIGURED": "The selected model is served by Anthropic and this assistant has no Anthropic key. Add one under AI providers or choose another model.",
    "leads": "Sales enquiries",
    "leadsHelp": "Customer-confirmed details and the outcome of their enquiry.",
    "leadFrom": "From (Peru time)",
    "leadThrough": "Through (Peru time)",
    "leadExport": "Download CSV",
    "leadNoData": "No confirmed enquiries in this period.",
    "leadNext": "Next",
    "leadFirst": "Back to first page",
    "leadCustomer": "Customer",
    "leadContact": "Contact",
    "leadRequest": "Need and context",
    "leadResult": "Outcome",
    "leadExportHelp": "CSV includes the entire selected period, up to 1,000 enquiries. For larger periods, select a shorter date range.",
    "LEAD_EXPORT_DATE_RANGE_REQUIRED": "More than 1,000 enquiries match. Select a shorter period to export all its results.",
    "leadDestination": "Save enquiries in",
    "leadAssist": "Assist: enquiries dashboard and CSV",
    "leadBusiness": "Connected business system",
    "saveConfigurationDraft": "Save draft",
    "configurationDraftSaved": "Saved changes have not been published. The published version remains active.",
    "publishConfigurationDraft": "Publish saved draft",
    "publishingConfiguration": "Publishing…",
    "publishingConfigurationHelp": "Publishing. If the personality or the model changed, preparing the assistant’s messages can take a few minutes.",
    "configurationPublished": "Published. New conversations use this version; conversations already open keep theirs.",
    "liveVersion": "Published version",
    "draftChanges": "The saved draft changes:",
    "draftUnchanged": "The saved draft changes nothing in the published version.",
    "summaryNone": "None",
    "CONFIGURATION_DRAFT_CONFLICT": "The draft changed in another session. Reload before saving.",
    "CONFIGURATION_INVALID": "Complete or correct these fields and save the draft before publishing. The published version remains active.",
    "CONFIGURATION_PUBLISHED_SINCE_EDIT": "Another version was published while you were editing. Reload to review the changes.",
    "appointmentServices": "Calls, visits and services",
    "appointmentServicesHelp": "Each service has its own calendar, duration and hours. Enable only what this business offers.",
    "addAppointmentService": "Add service",
    "serviceName": "Customer-facing service name",
    "serviceLocation": "Location or address",
    "serviceAppointment": "Service appointment",
    "APPOINTMENT_SERVICE_REQUIRED": "Specify which service the customer wants to book.",
    "APPOINTMENT_SERVICE_NOT_FOUND": "This service is no longer available.",
    "chooseApprovedSource": "Choose approved information",
    "chooseSourcePassage": "Choose the fact supporting this benefit",
    "sourceEvidenceChanged": "The saved evidence no longer matches this source. Choose current evidence before publishing.",
    "businessIdentity": "Business and customers",
    "businessDescription": "What does this business offer?",
    "businessAudience": "Whom does it serve?",
    "personalityAndSales": "Personality and sales approach",
    "configurationUnsaved": "There are unsaved changes. Save the draft before publishing.",
    "createClient": "Create client",
    "createClientHelp": "Create an installation without publishing the assistant. Select the agreed plan and period, then configure information, appointments and channels.",
    "clientLegalName": "Legal business name",
    "clientPlan": "Agreed monthly plan",
    "clientChoosePlan": "Select the plan",
    "clientPeriodStarts": "Period starts (Peru)",
    "clientPeriodEnds": "Period ends, exclusive (Peru)",
    "INSTALLATION_OPERATOR_REQUIRED": "Your account is not authorized to create clients.",
    "INSTALLATION_REQUEST_CONFLICT": "This installation request already exists with different details.",
    "configurationPreview": "Preview draft",
    "configurationPreviewHelp": "Uses the configured models and current sources. Reads real information and availability, but stops before saving enquiries or booking. Previews do not count as customer conversations; model usage is recorded.",
    "previewCustomer": "Preview customer",
    "previewMessage": "Message to try",
    "previewSend": "Try message",
    "previewReset": "Restart preview",
    "previewActionBoundary": "The preview reached an action requiring confirmation. No enquiry was saved, booking made or message sent. Restart to try another journey.",
    "PREVIEW_REPLY_REQUIRES_REVIEW": "The reply did not pass source or communication review. Review the draft and its sources.",
    "PREVIEW_ACTION_UNAVAILABLE": "This action is unavailable in this configuration.",
    "exportPublishedConfiguration": "Export published configuration",
    "productSalesUnavailable": "Product sales: unavailable until a product, order and payment system is connected.",
    "qualifiedLeadOutcome": "Save confirmed customer enquiries",
    "appointmentOutcome": "Book configured calls, visits or services",
    "productSaleOutcome": "Confirm orders and take payment by link (provider required; unavailable)",
    "appointmentRequiresLead": "Every booking first saves the customer's confirmed enquiry.",
    "configurationSources": "Information and offerings",
    "configurationSourcesHelp": "Approve supporting information and connect current-data sources. Save your changes before opening another section.",
    "approvedSourceOrigins": "Domains approved for this client",
    "approvedSourceOriginsHelp": "Approve only client or provider domains. Use the exact HTTPS origin, without paths. Existing platform authorizations are managed separately.",
    "sourceOrigin": "Source HTTPS origin",
    "approveSourceOrigin": "Approve domain",
    "SOURCE_ORIGIN_INVALID": "Use only the HTTPS origin, without a path, query or fragment.",
    "SOURCE_ORIGIN_LIMIT_REACHED": "The limit of 20 domains per source type has been reached.",
    "SALES_APPROACH_REQUIRED": "Configure the sales approach before publishing a sales assistant.",
    "SALES_EVIDENCE_CHANGED": "A sales benefit no longer matches the published information. Choose the current source fact again before publishing.",
    "catalogSettings": "Catalog",
    "catalogSettingsHelp": "The bot reads the connected source. Its permissions determine which products are visible.",
    "catalogType": "Product type",
    "catalogMaxChatCards": "Maximum cards per reply",
    "catalogSourceDefault": "Use the type supplied by the source",
    "catalogProperty": "Properties",
    "catalogGeneral": "Other products",
    "catalogLabel": "Product name",
    "catalogReferenceTerms": "Product reference words (comma separated)",
    "catalogAttributesHelp": "Select the public information the bot can use. Missing values remain unknown.",
    "catalogField": "Source field",
    "catalogAttributeLabel": "Attribute label",
    "catalogValueType": "Value type",
    "catalogUnit": "Unit or currency (PEN / USD for prices)",
    "catalogType_text": "Text",
    "catalogType_number": "Number",
    "catalogType_decimal": "Exact decimal",
    "catalogType_boolean": "Yes / no",
    "catalogType_text_list": "Text list",
    "catalogType_money": "Amount in minor units",
    "catalogRemoveAttribute": "Remove attribute",
    "catalogAddAttribute": "Add attribute",
    "CATALOG_PROFILE_MISMATCH": "The catalog type does not match the connected source. Select the type supplied by the source.",
    "CATALOG_CAPABILITY_REQUIRED": "The source must declare its catalog type and support product searches.",
    "CATALOG_PAGES_REQUIRED": "The source returned products without page metadata. Check its connector contract.",
    "modelCredentials": "Model API keys",
    "modelCredentialsHelp": "Choose who supplies the OpenAI and Jev keys for this Assist. Changes apply immediately to new model operations.",
    "modelCredentialSource": "Key source",
    "modelCredentialPlatform": "Platform keys",
    "modelCredentialOwn": "Require this Assist’s own keys",
    "modelCredentialStrict": "All model workflows use this Assist’s keys. Missing or rejected keys stop the operation; platform keys are never substituted.",
    "openaiApiKey": "OpenAI API key",
    "anthropicApiKey": "Anthropic API key (optional)",
    "anthropicKeyHelp": "Needed only by assistants that reply with a Claude model. Leave it empty to keep the saved key.",
    "jevApiKey": "Jev API key",
    "modelKeyStored": "Key stored securely. Leave blank to keep it, or enter a replacement.",
    "modelKeyRequired": "A key is required. Stored keys are never displayed.",
    "saveModelCredentials": "Save API key settings",
    "modelCredentialsSaved": "API key settings saved.",
    "BOT_MODEL_KEYS_REQUIRED": "Provide both the OpenAI and Jev keys before requiring this Assist’s own keys.",
    "BOT_MODEL_CREDENTIAL_POLICY_MISSING": "The key-source policy for this Assist is missing. An administrator must check the installation; no alternative keys will be used.",
    "accountAiProviders": "AI providers",
    "accountKeysHelp": "Manage your account keys and choose which keys each assistant must use. Changes apply to new model operations.",
    "credentialProfiles": "Saved credentials",
    "addCredentialProfile": "Add credentials",
    "noCredentialProfiles": "No account credentials saved. Use platform credentials or add your company’s keys.",
    "credentialsEncrypted": "OpenAI and Jev · Encrypted at rest",
    "credentialsEncryptedWithAnthropic": "OpenAI, Jev and Anthropic · Encrypted at rest",
    "credentialProfileName": "Name for these credentials",
    "replaceSharedKeysHelp": "Leave a key empty to keep it. Replacing it affects every assistant assigned to these credentials.",
    "newSharedKeysHelp": "Add both keys. You can then assign them to one or more assistants in this account.",
    "credentialAssignments": "Credentials by assistant",
    "ownKeysRequired": "own keys required",
    "setupNavigation": "Assistant setup",
    "setupBusiness": "Business",
    "setupInformation": "Information",
    "setupVoice": "Voice",
    "setupAppointments": "People & appointments",
    "setupChannels": "Channels",
    "setupReview": "Test & publish",
    "setupBusinessHelp": "Start with the essentials: what your business offers, who it helps and what the assistant should accomplish.",
    "setupInformationHelp": "Connect reliable information. Prices and availability come from the connected source; documents require review.",
    "setupVoiceHelp": "Describe how the assistant should speak. Use your own words and keep the rules it must follow here.",
    "setupModel": "Model",
    "setupModelHelp": "Choose the model that writes replies, how much it reasons and how fast it runs. These settings decide reply time and the cost of every conversation.",
    "setupAppointmentsHelp": "Choose the services the assistant can book and who provides each one.",
    "setupChannelsHelp": "Choose where to serve your customers and review how each conversation begins.",
    "setupReviewHelp": "Test the draft with real questions. Publish when its answers and actions are correct.",
    "edit": "Edit",
    "remove": "Remove",
    "home": "Home",
    "assistants": "Assistants",
    "accountSettings": "Account",
    "accountTeam": "Team & advisers",
    "help": "Help",
    "workspaceSections": "Workspace sections",
    "homeHelp": "Review what needs attention and continue your work.",
    "assistantOverviewHelp": "Configure, review and test your assistant before publishing changes.",
    "noUnpublishedDraft": "No unpublished changes",
    "notPublished": "Not yet published",
    "published": "Published",
    "helpIntroduction": "Each section has a task. Start by setting up the assistant and return here when you need guidance.",
    "helpSetup": "Set up an assistant",
    "helpSetupBody": "Open Assistants → Configure. Complete business, information, voice, people and appointments, and channels. Save the draft; customer replies change only after publication.",
    "helpDaily": "Serve your customers",
    "helpDailyBody": "In Conversations, review messages and take control when needed. Contacts contains confirmed enquiries. Human support shows pending cases and their assigned operator.",
    "helpAccounts": "Manage the account",
    "helpAccountsBody": "Account contains AI credentials, team, connections and usage. Own credentials can be assigned to several assistants. Requiring own keys stops operations when those keys fail.",
    "helpPublishing": "Save, test and publish",
    "helpPublishingBody": "Saving retains a draft. Testing lets you review its answers without changing the public version. Publishing activates the configuration for new conversations. Applying policy to open conversations is a separate action that preserves pending operations.",
    "ACCOUNT_ACCESS_FORBIDDEN": "Only this account’s administrators can manage this section.",
    "CREDENTIAL_PROFILE_IN_USE": "These credentials are still assigned to an assistant. Change that assignment before removing them.",
    "ACCOUNT_CREDENTIAL_LIST_LIMIT": "This account exceeds the credential or assistant limit for this view. Contact the platform administrator.",
    "adviserDirectoryHelp": "Manage the people who serve your customers. Link their calendars and authorize assistants to book with them.",
    "adviserDirectory": "Advisers",
    "addAdviser": "Add adviser",
    "editAdviser": "Edit adviser",
    "noAdvisers": "You have not added advisers to this account yet.",
    "adviserActive": "Accepting bookings",
    "adviserInactive": "Not accepting new bookings",
    "adviserName": "Adviser name",
    "adviserEmail": "Adviser email",
    "adviserAcceptsBookings": "Accept new bookings",
    "authorizedAssistants": "Authorized assistants",
    "adviserGrantHelp": "Only these assistants can offer appointments with this person. This does not grant dashboard access.",
    "adviserWorkingHours": "Working hours",
    "noAdviserHours": "Add at least one working window to offer appointments. No hours means no bookable slots.",
    "weekday": "Day",
    "addWorkingWindow": "Add working window",
    "availabilityExceptions": "Availability exceptions",
    "availabilityExceptionsHelp": "An exception replaces normal hours on that date. Leave it without windows to mark the whole day unavailable.",
    "exceptionDate": "Date",
    "unavailableAllDay": "Unavailable all day",
    "addAvailabilityException": "Add date exception",
    "saveAdviser": "Save adviser",
    "backToAdvisers": "Back to advisers",
    "adviserCalendars": "Adviser calendars",
    "adviserCalendarsHelp": "Every added calendar blocks busy times. Each service selects the calendar where bookings are created.",
    "calendarCanBook": "Bookings allowed",
    "calendarConflictOnly": "Busy-time checking only",
    "selectCalendarAccount": "Select a connected account",
    "selectCalendar": "Select a calendar",
    "addAdviserCalendar": "Add adviser calendar",
    "connectCalendarAccount": "Connect another calendar account",
    "calendarOAuthHelp": "This connection requests calendar access. It does not request mailbox access. Connect only accounts you are authorized to use.",
    "ADVISER_REVISION_CONFLICT": "Someone else changed this adviser. Keep your edits and reopen the adviser to compare before saving.",
    "ADVISER_NOT_ELIGIBLE": "This adviser is inactive or is not authorized for the assistant.",
    "ADVISER_CALENDAR_LIMIT": "An adviser can use up to 20 calendars.",
    "CALENDAR_ACCOUNT_UNAVAILABLE": "The calendar connection is unavailable. Reconnect it in Account.",
    "CALENDAR_NOT_AVAILABLE": "This calendar is no longer available in the connected account.",
    "bookingCalendar": "Calendar for bookings",
    "serviceAdvisers": "Who provides this service",
    "adviserAssignmentHelp": "Offer the earliest appointment first. When several advisers are free at the same time, rotate bookings fairly. Check all their calendars for conflicts.",
    "noEligibleAdvisers": "No advisers are authorized yet. An administrator can add them and authorize this assistant in Account → Team.",
    "selectAdviser": "Select an adviser",
    "bookingRules": "Notice and time between appointments",
    "bookingRulesHelp": "These limits apply alongside service hours, each adviser’s hours and their calendars.",
    "noticeMinutes": "Minimum notice (minutes)",
    "bufferBeforeMinutes": "Free time before (minutes)",
    "bufferAfterMinutes": "Free time after (minutes)",
    "horizonDays": "Book up to (days from today)",
    "directCalendarHelp": "This service uses an existing calendar connection. Select an adviser team to distribute bookings.",
    "useAdviserTeam": "Set up an adviser team",
    "newService": "New service",
    "serviceWorkingHours": "When this service is offered",
    "serviceHoursHelp": "Set the windows in which an appointment can start and finish. The adviser must also be free for the full appointment and its buffers.",
    "crmAdviserLinks": "Adviser identity in CRM",
    "crmAdviserLinksHelp": "Link the correct person so CRM appointments identify who will meet the customer. This link does not change the lead owner or grant Assist access.",
    "crmPerson": "CRM adviser",
    "linkCrmAdviser": "Confirm this adviser link",
    "unlinkCrmAdviser": "Remove link",
    "crmLinked": "Linked to CRM",
    "crmSelectConnection": "Select the assistant’s CRM",
    "crmNoConnections": "This assistant has no connected CRM. Connect it in Account → Connections.",
    "dashboardAccess": "Dashboard access",
    "dashboardAccessHelp": "Invite people who manage the business or handle conversations. Being a booking adviser does not grant dashboard access.",
    "invitePerson": "Invite a person",
    "assistantAccess": "Assistants this person can access",
    "assistantAccessHelp": "Select each assistant and its permission. Account permissions do not automatically grant access to conversations.",
    "accessRole": "Permission",
    "accountRole": "Account permission",
    "accountRoleHelp": "Member: selected assistants only. Administrator: manages keys, connections and team. Owner: also manages other owners.",
    "member": "Member",
    "assistantAccessOnly": "Assistant permissions only",
    "editAccess": "Edit permissions",
    "invitationEmail": "Email used to sign in",
    "invitationSender": "Send from",
    "selectMailbox": "Select a connected mailbox",
    "invitationSenderHelp": "Connect a mailbox in Account → Connections to send invitations.",
    "invitationConfirmation": "Send a link valid for 7 days. The person must sign in with this email and accept the permissions.",
    "sendInvitation": "Send invitation",
    "invitationSent": "The email provider confirmed that the invitation was sent.",
    "linkAdviserLogin": "This login belongs to adviser",
    "saveAccess": "Save permissions",
    "revokeInvitation": "Revoke invitation",
    "checkInvitationDelivery": "Check delivery",
    "expiresAt": "Expires:",
    "invitation_queued": "Waiting to send",
    "invitation_preparing": "Preparing email",
    "invitation_prepared": "Email prepared",
    "invitation_sending": "Sending",
    "invitation_sent": "Sent; awaiting acceptance",
    "invitation_uncertain": "The provider has not confirmed delivery",
    "invitation_failed": "Email preparation failed",
    "invitation_accepted": "Accepted",
    "invitation_revoked": "Revoked",
    "invitationReview": "Review your invitation",
    "invitationFor": "Invitation for",
    "signedInAs": "Signed in as",
    "acceptInvitation": "Accept these permissions",
    "useAnotherAccount": "Use another account",
    "invitationSignInHelp": "Sign in with the invitation email to continue.",
    "INVITATION_NOT_AVAILABLE": "This invitation is unavailable or expired. Ask the administrator for a new one.",
    "INVITATION_EMAIL_MISMATCH": "Sign in with the email address that received this invitation.",
    "INVITATION_ALREADY_PENDING": "An active invitation already exists for this email. Check its status below.",
    "INVITATION_DELIVERY_UNCONFIRMED": "Delivery remains unconfirmed. Check its status before inviting again.",
    "INVITATION_DELIVERY_IN_PROGRESS": "Delivery is in progress. Check its status in a few minutes.",
    "INVITATION_SENDER_REQUIRED": "Select a connected mailbox.",
    "ADVISER_LOGIN_ALREADY_LINKED": "This login is already linked to another adviser. An administrator must review the link.",
    "ACCOUNT_OWNER_REQUIRED": "This change requires an account owner.",
    "accountSettingsHelp": "Manage your account and shared resources. Choose access to each assistant separately.",
    "companyAccount": "Company account",
    "appliesToAssistant": "Assistant using these settings",
    "accountAssistantScopeHelp": "Connections and usage belong to the selected assistant. Switching assistants does not share their data.",
    "privacyAccountAccessHelp": "You need administrator access to this assistant to manage customer data. Request that access in Team.",
    "ACCOUNT_BOT_SCOPE_INVALID": "This assistant does not belong to the selected account.",
    "ACCESS_FORM_UNSAVED": "Save access changes or cancel the form before leaving. Invitations are sent only when you choose Send invitation.",
    "linkExistingLogin": "Link someone who already has access",
    "showLinkedMembers": "Show this adviser’s linked logins",
    "INVITATION_ACCESS_CHANGED": "Your current permissions differ from this invitation. Ask the administrator to review access and send a new invitation.",
    "INVITATION_DELIVERY_CLAIM_LOST": "Another process is handling delivery. Refresh its status before retrying.",
    "previousStep": "Back",
    "nextStep": "Continue",
    "removeWorkingWindow": "Remove hours",
    "agenda": "Appointments",
    "agendaHelp": "Appointments created by this assistant, most recently arranged first. Each calendar is checked for the current status. Open the conversation to reschedule or cancel.",
    "agendaEmpty": "There are no recorded appointments on this page.",
    "agendaCalendarUnavailable": "We could not check this calendar. The appointment’s current status is unconfirmed. Retry or review its calendar connection in Team.",
    "agendaRemoved": "The provider no longer finds this appointment in the calendar.",
    "agendaCheckedAt": "Checked with the calendar:",
    "agendaSynchronizationRequired": "The calendar acknowledged a booking, but Assist still needs to complete its record. Open the conversation to review the operation.",
    "agendaOpenConversation": "Open conversation and manage appointment",
    "agendaOlder": "Earlier bookings",
    "CRM_ADVISER_NOT_ELIGIBLE": "The linked adviser is no longer available in this CRM. Review the link before accepting new appointments.",
    "additionalVoiceRules": "Additional instructions and signature",
    "additionalVoiceRulesHelp": "Use this section for rules you have not already described above. Manage business facts in Information and bookings in People & appointments.",
    "ADVISER_BOOKING_CALENDAR_UNAVAILABLE": "This adviser’s booking calendar is unavailable. Review their calendars in Team.",
    "ADVISER_CALENDAR_ACCESS_REQUIRED": "Access to an adviser’s calendar is missing. Reconnect the account before offering appointments.",
    "ADVISER_CRM_LINK_REQUIRED": "Link this adviser to a CRM person before enabling bookings for that system.",
    "ADVISER_POOL_UNAVAILABLE": "No active, authorized advisers are available for this service. Review the team and its access.",
    "ADVISER_BOT_SCOPE_INVALID": "A selected assistant does not belong to this company. Refresh the list and save again.",
    "CRM_ADVISER_DIRECTORY_UNAVAILABLE": "This CRM connection does not expose its adviser directory. Enable that capability in the CRM installation.",
    "CRM_APPOINTMENT_HOST_UNAVAILABLE": "This CRM connection does not support assigning appointment hosts. Enable that capability in the CRM installation.",
    "CALENDAR_SLOT_UNAVAILABLE": "That time is no longer available. Check availability and choose another slot.",
    "CALENDAR_CONFIGURATION_CHANGED": "The booking configuration changed. Refresh the page and check availability again.",
    "LAST_OWNER_REQUIRED": "At least one owner must remain. Assign another owner before removing this access.",
    "INVITATION_ALREADY_ACCEPTED": "Another account already accepted this invitation. Request a new invitation.",
    "ACCOUNT_MEMBER_NOT_FOUND": "This person no longer has access to the account. Refresh the list.",
    "OFFICE_REAUTHORIZATION_REQUIRED": "The Google or Microsoft authorization expired. Reconnect the account.",
    "CONNECTION_RECONNECTION_REQUIRED": "This connection needs a new Google or Microsoft authorization. Reconnect the same account; re-enabling it does not restore access.",
    "OFFICE_REQUIRED_PERMISSIONS_MISSING": "The account did not grant the required permissions. Reconnect and review the requested permissions.",
    "CONNECTION_DISABLED": "The connection is disabled. Enable it or choose another connection.",
    "ACCOUNT_INVITATION_LIMIT": "There are too many pending invitations. Revoke invitations you no longer need before sending another.",
    "connectedCalendars": "Calendar accounts",
    "connectedCalendarsHelp": "Connect an account, then choose its calendars in Team and advisers. Each adviser can combine several calendars to avoid conflicts.",
    "noCalendarAccounts": "No calendar accounts are connected yet.",
    "calendarReconnectHelp": "This connection needs attention. Reconnect the same account to restore access.",
    "calendarReconnectRequired": "A calendar account's authorization expired. The assistant cannot offer or book times until you reconnect it.",
    "disconnectCalendarHelp": "Advisers using this account will be unable to check or change appointments until you reconnect it. Existing appointments remain with the provider.",
    "reconnectCalendar": "Reconnect",
    "disconnectCalendar": "Disconnect",
    "confirmDisconnectCalendar": "Confirm disconnection",
    "CREDENTIAL_FORM_UNSAVED": "Save the credentials or cancel editing before leaving this section.",
    "ADVISER_FORM_INVALID": "Complete the adviser’s details and correct the fields below. Working windows must end after they start and must not overlap.",
    "assistantAdministration": "Assistant administration"
  }
}
